var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindDifferent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 428,
    viewBox: "0 0 397 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1515_6838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1876 276.882L0 269.831L169.134 172.137L181.322 179.188L12.1876 276.882Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.281 177.419L9.14746 275.113H15.2551L114.303 224.925L181.321 179.189L180.548 176.866L178.281 177.419Z",
    fill: "url(#paint0_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.321 24.3937L169.134 17.3701V172.137L181.321 179.189V24.3937Z",
    fill: "#F7EACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.281 22.6514L169.134 26.1908V172.137L181.321 179.188L182.565 125.737L181.321 30.5045L178.281 22.6514Z",
    fill: "url(#paint1_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.284 290.681L326.826 289.216L183.864 207.781L196.079 200.73L396.276 199.928L593.71 313.992L581.522 321.043H396.774L211.528 428.055H197.461L339.898 345.764L284.432 313.715L324.284 290.681Z",
    fill: "url(#paint2_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.189 276.606L312.98 275.002L314.224 274.283H326.135L382.706 306.94L337.798 332.877L335.891 331.799H326.052L270.337 299.612L310.189 276.606Z",
    fill: "#B09567"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.647 306.919L197.401 413.931L12.1279 306.919L197.401 199.906L382.647 306.919Z",
    fill: "#FFECBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.555 302.101L225.401 244.253L248.505 230.897H267.961L269.923 229.764H273.461L275.395 230.897H275.423L276.639 231.616L278.242 232.529L279.845 233.441L281.42 234.382L283.023 235.294L286.229 237.147L287.804 238.059L289.407 238.972L291.01 239.912L342.054 269.389L343.657 270.329L345.26 271.241L346.863 272.154L351.644 274.919L353.247 275.859L354.822 276.772L356.425 277.684L358.028 278.624L359.603 279.537L361.206 280.449L362.809 281.39L364.412 282.302L365.987 283.215L367.59 284.155L369.193 285.067L370.796 285.98L372.371 286.92L373.974 287.833L375.577 288.745L377.539 289.879L352.473 304.368H348.963L345.039 302.101H325.555Z",
    fill: "url(#paint3_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.385 237.036L273.986 238.999L269.536 240.078L244.83 241.46H239.054L233.72 240.188L229.63 237.838L227.419 234.741V233.994H204.066V234.741L201.855 237.838L197.765 240.188L192.431 241.46H186.655L181.294 240.188L177.204 237.838L174.993 234.741V231.395L177.204 228.326L181.294 225.948L186.655 224.676H192.431L197.765 225.948L201.855 228.326L204.066 231.395V232.142H227.419V231.395L229.63 228.326L233.72 225.948L239.054 224.676H244.83L269.536 226.058L273.986 227.137L277.385 229.1L279.237 231.672V234.465L277.385 237.036Z",
    fill: "url(#paint4_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.411 283.656L196.494 283.297L196.411 282.937L181.128 274.117H226.397L209.511 283.878C201.856 288.302 194.2 292.726 186.545 297.151H173.086L196.411 283.684V283.656ZM166.426 255.479H171.649C173.86 256.751 176.071 258.023 178.254 259.295L178.337 259.655L178.254 260.014L167.725 266.098H240.325C253.591 258.438 266.884 250.751 280.149 243.091H187.899L166.398 255.507L166.426 255.479ZM105.239 290.818L116.183 297.123H94.3228L105.267 290.818H105.239ZM130.112 305.197L139.508 310.645C142.935 310.645 146.334 310.645 149.761 310.645L159.158 305.197H193.869C249.224 273.204 304.58 241.239 359.935 209.245H366.043L394.37 192.875L382.182 185.824H197.434L169.107 202.194L181.294 209.245L64.5309 276.688L12.1602 306.939L14.0394 308.018H23.2699L25.1492 306.939H74.3418L77.3818 305.17H130.057L130.112 305.197ZM201.856 235.017C215.121 227.357 228.414 219.67 241.679 212.011H333.929L317.044 221.772L294.105 235.017H201.856Z",
    fill: "url(#paint5_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.2 343.468L200.97 399.049L62.5127 319.052L158.742 263.472L297.2 343.468Z",
    fill: "#D4C6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.971 399.048C200.971 398.025 288.384 347.394 297.2 343.468C255.884 367.331 242.287 375.184 200.971 399.048Z",
    fill: "#848169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5291 305.198L93.5487 301.133L100.458 297.151H116.183L108.334 292.616L158.743 263.499L195.057 284.487L173.086 297.179H186.545L201.772 288.386L212.385 294.524L193.841 305.226H159.13L149.733 310.673C146.306 310.673 142.907 310.673 139.48 310.673L130.084 305.226H86.5015L86.5291 305.198Z",
    fill: "url(#paint6_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.433 15.1025L382.707 122.115V306.94L197.433 199.927V15.1025Z",
    fill: "#F7EACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.433 15.1025L382.707 122.115V306.94L197.433 199.927V15.1025Z",
    fill: "#86C46C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.351 296.93L251.048 230.898V213.947L249.085 208.914V205.375L251.048 206.509L252.264 207.228L253.867 208.14L255.469 209.08L257.072 209.993L258.648 210.905L261.853 212.758L263.456 213.671L265.032 214.611L266.634 215.523L317.706 245.028L319.282 245.94L320.884 246.853L322.487 247.793L327.268 250.558L328.871 251.471L330.447 252.383L332.05 253.323L333.652 254.236L335.255 255.148L336.831 256.088L338.434 257.001L340.036 257.913L341.639 258.854L343.215 259.766L344.817 260.679L346.42 261.619L348.023 262.531L349.599 263.444L351.201 264.384L353.164 265.518L365.351 296.93Z",
    fill: "url(#paint7_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 269.831L12.1876 276.882V321.042L0 313.991V269.831Z",
    fill: "#F7EACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.134 17.3699L181.321 24.3935L209.649 8.05122L197.433 1L169.134 17.3699Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.895 115.064L382.707 122.115L185.246 8.05122L197.434 1L394.895 115.064Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.434 428.055V413.953L0 299.889V313.991L197.434 428.055Z",
    fill: "#F7EACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.433 418.322V413.953L12.1875 306.94V311.309L197.433 418.322Z",
    fill: "#E6D2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.461 428.055L197.433 413.953L394.894 299.889V313.991L197.461 428.055Z",
    fill: "#B49F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.896 115.063L382.708 122.115V321.042L394.896 313.991V115.063Z",
    fill: "#B49F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.433 15.1025L181.322 24.3936V179.189L12.1875 276.882V306.94L197.433 199.927L204.702 120.898L197.433 15.1025Z",
    fill: "url(#paint8_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.768 240.576L241.043 225.118V220.556L243.448 199.651L245.272 198.103L248.671 200.038L253.093 205.209L257.902 212.813L262.323 221.662L265.723 230.455L267.547 237.811L267.768 240.576Z",
    fill: "url(#paint9_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.754 251.525L276.141 245.387L272.134 235.017V243.064L258.205 235.017V199.098L235.267 139.923L235.019 139.259L218.409 129.664V133.148L227.446 138.374L240.546 172.165V176.478L218.409 163.703V188.728L230.072 218.786L197.516 199.982V125.405V121.092V91.3936V87.08V15.1299L213.628 56.6906V62.8016L286.809 251.553L286.754 251.525ZM219.708 99.8828L218.354 96.371V99.1085L219.708 99.8828Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.505 120.069L197.433 57.3271L210.56 91.1177L326.605 158.146V153.832L313.505 120.069Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.8 308.046L197.433 202.112V192.876L380.827 298.783L380.8 308.046Z",
    fill: "url(#paint10_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.8 308.046L363.472 298.008L347.581 284.542L248.45 231.589L197.433 202.112V192.876L380.827 298.783L380.8 308.046Z",
    fill: "url(#paint11_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 297.704L29.8471 287.528L31.7263 288.607L14.0944 298.783L12.1875 297.704Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.707 297.704L197.461 190.691L195.554 191.77L380.828 298.782L382.707 297.704Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.736 285.011L336.499 271.02L334.62 272.098L358.857 286.09L360.736 285.011Z",
    fill: "url(#paint12_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 297.704L197.461 190.691L199.34 191.77L15.9737 297.704H12.1875Z",
    fill: "url(#paint13_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8203 94.8232L62.9279 98.335V235.018L56.8203 231.479V94.8232Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8203 94.8232L62.9279 98.335V110.557L56.8203 94.8232Z",
    fill: "url(#paint14_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8887 258.024L16.9963 261.536L62.9278 235.018L56.8202 231.479L10.8887 258.024Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8887 258.023L16.9963 261.535L23.0763 258.023H10.8887Z",
    fill: "url(#paint15_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.573 63.7422L116.68 67.2816V203.937L110.573 200.425V63.7422Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.353 32.6885L170.433 36.2279V172.883L164.353 169.372V32.6885Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.573 63.7422L116.68 67.2816V79.5037L110.573 63.7422Z",
    fill: "url(#paint16_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6411 226.971L70.7487 230.482L116.68 203.937L110.573 200.425L64.6411 226.971Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.422 195.89L124.502 199.43L170.433 172.884L164.353 169.372L118.422 195.89Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14765 120.345L3.04004 116.833L172.174 19.1113L178.282 22.6508L9.14765 120.345Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6411 226.943L70.7487 230.483L76.8563 226.943H64.6411Z",
    fill: "url(#paint17_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.422 195.891L124.502 199.43L130.609 195.891H118.422Z",
    fill: "url(#paint18_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.501 53.7041L9.14746 120.345V275.112L124.501 208.471V53.7041ZM116.68 67.2812V203.964L70.7487 230.51V93.8269L116.68 67.2812ZM62.9276 98.3342V235.017L16.9962 261.563V124.88L62.9276 98.3342Z",
    fill: "url(#paint19_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.282 22.6514L62.9277 89.2923V244.06L178.282 177.419V22.6514ZM170.433 36.2284V172.911L124.501 199.457V62.7465L170.433 36.2008V36.2284ZM116.68 67.2814V203.964L70.7488 230.51V93.8272L116.68 67.2814Z",
    fill: "url(#paint20_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04004 116.833L9.14766 120.345V275.112L3.04004 271.6V116.833Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.708 306.94L386.467 304.783V119.931L382.708 122.115V306.94Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.433 15.1025L201.219 12.918L386.465 119.931L382.707 122.115L197.433 15.1025Z",
    fill: "#B8DAA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0944 308.046L12.1875 306.94V297.704L14.0944 298.783V308.046Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.8 308.046L382.707 306.94V297.704L380.828 298.783L380.8 308.046Z",
    fill: "url(#paint21_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.874 252.632L274.262 246.493L269.647 234.575L280.259 240.714L284.874 252.632ZM268.348 243.064L254.419 235.017V225.782L268.348 233.828V243.064ZM228.137 219.837L197.461 202.112L196.383 197.853L197.461 192.876L223.522 207.946L228.137 219.864V219.837Z",
    fill: "url(#paint22_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.472 298.008L332.768 280.284L331.718 276.025L332.796 271.048L358.857 286.118L363.472 298.008Z",
    fill: "url(#paint23_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.139 239.608L280.26 240.686L269.648 234.547L270.919 233.801H268.349L254.42 225.754H258.179L282.139 239.608ZM225.402 206.84L197.462 190.691L195.583 191.77L223.523 207.919L225.402 206.84Z",
    fill: "url(#paint24_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0947 308.046L197.461 202.112L197.434 192.876L14.0947 298.783V308.046Z",
    fill: "url(#paint25_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.853 367.138H261.025C263.236 368.41 269.454 372.005 271.637 373.277L271.72 373.637L271.637 373.996L221.063 403.196H219.653C216.199 403.196 200.667 403.196 197.213 403.196H186.877C184.666 401.924 178.448 398.33 176.264 397.058L176.182 396.698L176.264 396.339L189.668 388.596L102.89 338.463L149.54 311.503L245.825 367.138H245.853Z",
    fill: "url(#paint26_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.853 367.138H256.244L200.971 399.049L186.269 390.56L189.668 388.596L102.89 338.463L149.54 311.503L245.853 367.138Z",
    fill: "url(#paint27_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.439 314.046V305.004L176.292 272.734V281.777L120.439 314.046Z",
    fill: "url(#paint28_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5527 277.711L127.182 220.168L131.106 222.408L31.4494 279.979L27.5527 277.711Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4497 279.979L131.106 222.408V255.673L31.4497 313.244V279.979Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.972 393.933L186.793 389.425L138.927 361.773L131.105 366.281L178.972 393.933Z",
    fill: "#D4C7A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.838 357.239L178.971 384.891L131.105 357.239L178.971 329.587L226.838 357.239Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.972 329.586L131.106 357.238L83.2402 329.586L131.106 301.935L178.972 329.586Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.107 301.935L83.2405 329.587L35.3745 301.935L83.2405 274.283L131.107 301.935Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.972 329.586L131.106 357.238L83.2119 329.586L131.078 301.935L178.972 329.586Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 273.758V264.716L84.1251 264.356L131.079 291.483L131.687 292.534V301.576L83.5171 273.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 273.758V264.716L84.1251 264.356L131.079 291.483L131.687 292.534V301.576L83.5171 273.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 265.435V274.449L130.499 301.576V292.561L83.5171 265.435Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 264.909V273.924L130.499 301.576V292.561L178.365 264.909Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1412 264.375L83.5332 265.429L130.491 292.555L131.099 291.501L84.1412 264.375Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.757 264.549L131.107 291.51L84.125 264.383L130.803 237.423L177.757 264.549Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 292.561L131.107 291.51L131.715 292.561H130.499Z",
    fill: "url(#paint29_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.715 292.561H130.499V301.603H131.715V292.561Z",
    fill: "url(#paint30_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.364 265.601V274.643L131.714 301.576V292.561L178.364 265.601Z",
    fill: "url(#paint31_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.748 264.532L131.082 291.501L131.69 292.555L178.356 265.586L177.748 264.532Z",
    fill: "url(#paint32_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.364 265.601L177.756 264.55L178.364 264.909V265.601Z",
    fill: "url(#paint33_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 265.435L84.1251 264.384L83.5171 264.716V265.435Z",
    fill: "url(#paint34_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6782 301.409V292.367L36.2862 292.008L83.2403 319.134L83.8482 320.185V329.227L35.6782 301.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3286 274.449V265.406L82.9366 265.047L129.891 292.173L130.499 293.224V302.266L82.3286 274.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6782 301.409V292.367L36.2862 292.008L83.2403 319.134L83.8482 320.185V329.227L35.6782 301.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6504 293.087V302.101L82.6321 329.256V320.213L35.6504 293.087Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.498 292.561V301.575L82.6323 329.227V320.212L130.498 292.561Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2769 292.025L35.6689 293.079L82.6269 320.206L83.2349 319.152L36.2769 292.025Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.89 292.202L83.2405 319.162L36.2588 292.036L82.9365 265.075L129.89 292.202Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6323 320.213L83.2403 319.162L83.8483 320.213H82.6323Z",
    fill: "url(#paint35_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8483 320.213H82.6323V329.255H83.8483V320.213Z",
    fill: "url(#paint36_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.498 293.252V302.294L83.8481 329.227V320.213L130.498 293.252Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.912 292.181L83.2417 319.142L83.8497 320.195L130.52 293.235L129.912 292.181Z",
    fill: "url(#paint37_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 293.253L129.891 292.202L130.499 292.562V293.253Z",
    fill: "url(#paint38_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6782 293.086L36.2586 292.035L35.6782 292.367V293.086Z",
    fill: "url(#paint39_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.075 307.963H159.848L156.78 309.733L159.848 311.503H175.075L234.576 345.846H225.429L222.389 347.616L225.429 349.386H240.684H244.194L247.234 347.616L272.079 333.292L203.43 293.64H199.893L175.075 307.963Z",
    fill: "#848169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.246 335.034L247.206 333.292V314.517L250.273 316.259L250.246 335.034Z",
    fill: "url(#paint40_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.428 349.386L222.388 347.616V328.841L225.428 330.611V349.386Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.848 311.502L156.78 309.733V290.957L159.848 292.727V311.502Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.273 335.034L253.313 333.292V314.517L250.273 316.259V335.034Z",
    fill: "#917843"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.429 349.386L228.496 347.616V328.841L225.429 330.611V349.386Z",
    fill: "#917843"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.848 311.502L162.888 309.733V290.957L159.848 292.727V311.502Z",
    fill: "url(#paint41_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.314 314.517L225.429 330.61L156.78 290.958L184.665 274.864L253.314 314.517Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.429 334.122V330.61L156.78 290.957L156.808 294.469L225.429 334.122Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.429 334.122V330.61L253.314 314.517V318.028L225.429 334.122Z",
    fill: "#917843"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8203 329.255V320.213L84.4283 319.854L131.078 346.814L131.686 347.865V356.907L83.8203 329.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 302.294V293.252L131.107 292.893L177.757 319.853L178.365 320.904V329.946L130.499 302.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8203 329.255V320.213L84.4283 319.854L131.078 346.814L131.686 347.865V356.907L83.8203 329.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8203 320.903V329.945L130.498 356.906V347.864L83.8203 320.903Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 320.213V329.255L130.499 356.907V347.865L178.365 320.213Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4381 319.866L83.8301 320.92L130.477 347.867L131.085 346.813L84.4381 319.866Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.756 319.853L131.106 346.814L84.4282 319.853L131.106 292.893L177.756 319.853Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 347.864L131.107 346.813L131.715 347.864H130.499Z",
    fill: "url(#paint42_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.715 347.864H130.499V356.906H131.715V347.864Z",
    fill: "url(#paint43_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.364 320.903V329.945L131.714 356.906V347.864L178.364 320.903Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.791 319.858L131.121 346.818L131.729 347.872L178.399 320.911L177.791 319.858Z",
    fill: "url(#paint44_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 320.904L177.757 319.854L178.365 320.213V320.904Z",
    fill: "url(#paint45_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8203 320.904L84.4283 319.854L83.8203 320.213V320.904Z",
    fill: "url(#paint46_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 356.907V347.864L132.322 347.505L178.972 374.465L179.58 375.516V384.558L131.714 356.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 329.947V320.904L178.973 320.545L225.623 347.505L226.231 348.556V357.598L178.365 329.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 356.907V347.864L132.322 347.505L178.972 374.465L179.58 375.516V384.558L131.714 356.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.688 348.556V357.598L178.365 384.558V375.516L131.688 348.556Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.231 347.865V356.907L178.365 384.559V375.517L226.231 347.865Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.306 347.52L131.698 348.573L178.345 375.52L178.953 374.466L132.306 347.52Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.623 347.505L178.973 374.466L132.295 347.505L178.973 320.545L225.623 347.505Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 375.517L178.973 374.466L179.581 375.517H178.365Z",
    fill: "url(#paint47_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.581 375.517H178.365V384.559H179.581V375.517Z",
    fill: "url(#paint48_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.232 348.556V357.598L179.582 384.558V375.516L226.232 348.556Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.629 347.511L178.958 374.472L179.566 375.525L226.237 348.565L225.629 347.511Z",
    fill: "url(#paint49_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.231 348.556L225.623 347.505L226.231 347.864V348.556Z",
    fill: "url(#paint50_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 348.556L132.295 347.505L131.714 347.864V348.556Z",
    fill: "url(#paint51_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.37 275.721L102.034 274.726L94.406 268.034L84.1253 264.384L83.5449 265.435L101.37 275.721Z",
    fill: "url(#paint52_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.627 287.417L122.291 286.422L108.362 278.375L107.699 279.37L121.627 287.417Z",
    fill: "url(#paint53_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.824 278.375L139.895 286.422H122.291L108.362 278.375H153.824ZM135.031 255.369L112.811 268.199H112.12L112.203 268.559L112.12 268.918L102.033 274.753L91.946 268.918L91.338 268.559L84.1249 264.383L130.775 237.423L147.909 247.322L148.435 247.626L161.838 255.369H135.031ZM100.568 275.278L90.73 269.61L82.9089 265.102L82.6602 264.964L36.3418 291.703L43.5549 295.879H63.7293H64.9453L81.2507 286.45H119.859L105.93 278.403H95.2071L100.568 275.306V275.278Z",
    fill: "url(#paint54_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1494 267.84L90.7574 268.2L91.3378 267.84L90.9785 266.485L90.1494 267.84Z",
    fill: "url(#paint55_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.016 240.188L90.1498 267.84L83.5171 264.024L131.411 236.372L138.016 240.188Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 243.313V264.025L90.1498 267.841V247.129L83.5171 243.313Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.015 219.478V240.189L90.1494 267.841V247.129L138.015 219.478Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1324 242.286L83.5244 243.34L90.1301 247.156L90.7381 246.102L84.1324 242.286Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.408 219.145L90.7577 246.078L84.125 242.262L130.803 215.329L137.408 219.145Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.27 225.561L112.341 233.607H99.1313L113.06 225.561H126.27Z",
    fill: "url(#paint56_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1494 247.129L90.7574 246.078L91.3378 247.129H90.1494Z",
    fill: "url(#paint57_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3654 247.129H90.1494V267.84H91.3654V247.129Z",
    fill: "url(#paint58_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.016 220.196V240.88L91.3379 267.84V247.129L138.016 220.196Z",
    fill: "url(#paint59_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.417 219.124L90.7466 246.085L91.3546 247.139L138.025 220.178L137.417 219.124Z",
    fill: "url(#paint60_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.016 220.196L137.408 219.146L138.016 219.477V220.196Z",
    fill: "url(#paint61_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5171 243.313L84.1251 242.263L83.5171 242.622V243.313Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6504 290.985V270.274L36.2584 269.914L42.8635 273.73L43.4715 274.781V295.492L42.8635 295.851L36.2584 292.036L35.6504 290.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2832 295.493L42.8912 295.852L43.4716 295.493L43.1123 294.138L42.2832 295.493Z",
    fill: "url(#paint62_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1491 267.84L42.2831 295.492L35.6504 291.676L83.5441 264.024L90.1491 267.84Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6504 270.965V291.676L42.2831 295.492V274.781L35.6504 270.965Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1492 247.129V267.84L42.2832 295.492V274.781L90.1492 247.129Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2776 269.926L35.6694 270.979L42.2745 274.797L42.8827 273.743L36.2776 269.926Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5415 246.797L42.8915 273.73L36.2588 269.914L82.9365 242.981L89.5415 246.797Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5177 256.613L58.589 264.66H45.3789L59.3076 256.613H72.5177Z",
    fill: "url(#paint63_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2832 274.781L42.8912 273.73L43.4716 274.781H42.2832Z",
    fill: "url(#paint64_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4992 274.781H42.2832V295.492H43.4992V274.781Z",
    fill: "url(#paint65_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1498 247.848V268.531L43.4722 295.492V274.781L90.1498 247.848Z",
    fill: "url(#paint66_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5552 246.768L42.8892 273.736L43.4973 274.79L90.1634 247.821L89.5552 246.768Z",
    fill: "url(#paint67_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1495 247.848L89.5415 246.797L90.1495 247.129V247.848Z",
    fill: "url(#paint68_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6504 270.965L36.2584 269.914L35.6504 270.274V270.965Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.685 292.035H72.7664C74.9773 293.307 109.716 313.382 111.927 314.654L112.01 315.014L111.927 315.373L105.322 319.189H103.913C100.458 319.189 97.0034 319.189 93.5765 319.189H83.2406C81.0297 317.917 46.2909 297.842 44.08 296.57L43.9971 296.211L44.08 295.851L50.685 292.035Z",
    fill: "url(#paint69_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4722 295.492V274.78L44.0802 274.421L83.2131 297.04L83.8211 298.091V318.802L83.2131 319.162L44.0802 296.542L43.4722 295.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6323 318.802L83.2403 319.162L83.8483 318.802L83.4614 317.447L82.6323 318.802Z",
    fill: "url(#paint70_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4538 314.295L82.6328 318.802L43.4722 296.183L51.2932 291.676L90.4538 314.295Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4722 275.5V296.184L82.6328 318.803V298.119L43.4722 275.5Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4534 293.584V314.295L82.6323 318.802V298.091L90.4534 293.584Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1046 274.439L43.4966 275.493L82.6521 298.112L83.2601 297.059L44.1046 274.439Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8457 293.224L83.2407 297.068L44.0801 274.449L50.6851 270.633L89.8457 293.224Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6323 298.091L83.2403 297.068L83.8483 298.091H82.6323Z",
    fill: "url(#paint71_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8483 298.091H82.6323V318.802H83.8483V298.091Z",
    fill: "url(#paint72_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4537 294.275V314.987L83.8486 318.803V298.091L90.4537 294.275Z",
    fill: "url(#paint73_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8651 293.234L83.2607 297.052L83.8691 298.105L90.4735 294.287L89.8651 293.234Z",
    fill: "url(#paint74_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4542 294.275L89.8462 293.225L90.4542 293.584V294.275Z",
    fill: "url(#paint75_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4722 275.5L44.0802 274.449L43.4722 274.781V275.5Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.061 315.346H113.142C115.353 316.618 157.609 341.034 159.792 342.306L159.875 342.666L159.792 343.025L153.187 346.841H151.778C148.323 346.841 144.869 346.841 141.442 346.841H131.106C128.895 345.569 86.6392 321.153 84.456 319.881L84.373 319.521L84.456 319.162L91.061 315.346Z",
    fill: "#9FA0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8481 318.803V298.092L84.4561 297.732L131.106 324.693L131.714 325.744V346.455L131.106 346.814L84.4561 319.854L83.8481 318.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 346.455L131.107 346.814L131.715 346.455L131.328 345.1L130.499 346.455Z",
    fill: "url(#paint76_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.319 341.947L130.498 346.454L83.8203 319.494L91.6414 314.986L138.319 341.947Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8479 298.811L83.8203 319.494L130.498 346.455V325.771L83.8479 298.811Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.32 321.235V341.947L130.499 346.454V325.743L138.32 321.235Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.443 297.718L83.835 298.771L130.506 325.732L131.114 324.678L84.443 297.718Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.711 320.876L131.106 324.72L84.4282 297.759L91.0609 293.943L137.711 320.876Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 325.743L131.107 324.72L131.715 325.743H130.499Z",
    fill: "url(#paint77_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.715 325.743H130.499V346.454H131.715V325.743Z",
    fill: "url(#paint78_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.319 321.927V342.638L131.714 346.454V325.743L138.319 321.927Z",
    fill: "url(#paint79_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.721 320.888L131.116 324.705L131.724 325.759L138.329 321.942L137.721 320.888Z",
    fill: "url(#paint80_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.319 321.927L137.711 320.876L138.319 321.235V321.927Z",
    fill: "url(#paint81_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8481 298.811L84.4285 297.76L83.8481 298.092V298.811Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.928 342.998H161.009C163.22 344.27 205.476 368.687 207.659 369.959L207.742 370.318L207.659 370.678L201.054 374.494H199.645C196.19 374.494 192.736 374.494 189.309 374.494H178.973C176.762 373.222 134.506 348.805 132.323 347.533L132.24 347.173L132.323 346.814L138.928 342.998Z",
    fill: "#9FA0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 346.454V325.743L132.322 325.384L178.972 352.344L179.58 353.395V374.106L178.972 374.466L132.322 347.505L131.714 346.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 374.107L178.973 374.466L179.581 374.107L179.221 372.779L178.365 374.107Z",
    fill: "url(#paint82_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.187 369.599L178.366 374.106L131.716 347.146L139.537 342.639L186.187 369.599Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 326.463V347.146L178.364 374.107V353.423L131.714 326.463Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.186 348.889V369.6L178.365 374.107V353.396L186.186 348.889Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31 325.398L131.702 326.452L178.373 353.413L178.981 352.359L132.31 325.398Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.577 348.556L178.972 352.372L132.322 325.412L138.927 321.596L185.577 348.556Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.365 353.395L178.973 352.372L179.581 353.395H178.365Z",
    fill: "url(#paint83_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.581 353.396H178.365V374.107H179.581V353.396Z",
    fill: "url(#paint84_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.186 349.579V370.29L179.581 374.106V353.395L186.186 349.579Z",
    fill: "url(#paint85_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.577 348.535L178.972 352.351L179.58 353.404L186.185 349.588L185.577 348.535Z",
    fill: "url(#paint86_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.185 349.58L185.577 348.557L186.185 348.888V349.58Z",
    fill: "url(#paint87_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.714 326.463L132.322 325.412L131.714 325.744V326.463Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5527 277.712L175.048 362.935V396.2L27.5527 310.977V277.712Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.048 362.935L178.972 360.667L31.4494 275.444L27.5527 277.712L175.048 362.935Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.048 362.935L178.945 360.668C178.945 378.476 178.945 376.125 178.945 393.933L175.048 396.201V362.935Z",
    fill: "url(#paint88_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.656 395.978V363.183L176.264 362.823L186.877 368.962L187.485 370.013V402.808L186.877 403.167L176.264 397.029L175.656 395.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.269 402.835L186.877 403.167L187.485 402.835L187.125 401.48L186.269 402.835Z",
    fill: "url(#paint89_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.059 372.916L186.269 402.835L175.656 396.697L227.447 366.777L238.059 372.916Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.656 363.901V396.696L186.269 402.835V370.012L175.656 363.901Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.059 340.121V372.916L186.269 402.808V370.013L238.059 340.121Z",
    fill: "#B4A682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.283 362.87L175.675 363.924L186.301 370.063L186.909 369.009L176.283 362.87Z",
    fill: "#F9F4E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.451 339.762L186.876 368.962L176.264 362.851L226.839 333.623L237.451 339.762Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.269 370.013L186.877 368.962L187.485 370.013H186.269Z",
    fill: "url(#paint90_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.485 370.013H186.269V402.808H187.485V370.013Z",
    fill: "url(#paint91_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.059 340.812V373.608L187.485 402.808V370.013L238.059 340.812Z",
    fill: "url(#paint92_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.463 339.73L186.891 368.944L187.499 369.998L238.071 340.784L237.463 339.73Z",
    fill: "url(#paint93_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.06 340.812L237.452 339.762L238.06 340.121V340.812Z",
    fill: "url(#paint94_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.656 363.874L176.264 362.851L175.656 363.182V363.874Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5527 277.712L175.048 362.935V396.2L27.5527 310.977V277.712Z",
    fill: "#E6DDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.451 339.763L186.876 368.963L176.264 362.852L226.839 333.624L237.451 339.763Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.377 359.893L191.16 354.252L193.095 355.358L193.178 355.717L193.095 356.049L186.49 359.865H185.08V359.893H181.377Z",
    fill: "url(#paint95_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.461 418.322L197.433 413.953L386.465 304.783V309.125L197.461 418.322Z",
    fill: "#A98A68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.666 274.864L189.889 277.878L175.131 286.423H164.657L184.666 274.864Z",
    fill: "#B4945F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.206 243.756L326.716 252.826V257.278L271.277 220.805L266.22 210.187L323.206 243.756Z",
    fill: "url(#paint96_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.16 237.34V179.41L330.668 175.511L252.485 130.383V188.313L254.005 192.185L332.16 237.34Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.187 311.503C225.154 312.057 226.149 312.637 227.116 313.19H230.46C230.792 312.997 231.151 312.775 231.51 312.582C232.201 312.969 232.865 313.356 233.528 313.743H236.872C237.397 313.439 237.95 313.107 238.502 312.803C239.221 313.218 239.939 313.633 240.686 314.047H242.758C244.113 313.273 245.467 312.499 246.821 311.697C243.947 310.038 241.1 308.379 238.226 306.72H236.153C235.352 306.25 234.523 305.78 233.721 305.309H231.649C231.041 304.95 230.405 304.591 229.797 304.231H229.3C227.78 303.346 226.287 302.489 224.767 301.604H221.423C220.511 302.13 219.599 302.655 218.715 303.18C217.775 302.627 216.836 302.102 215.896 301.549H214.238C212.911 302.323 211.585 303.07 210.258 303.844C208.932 304.618 207.605 305.365 206.306 306.139C209.401 307.936 212.497 309.706 215.592 311.503C215.592 311.974 215.592 312.444 215.592 312.941H218.052C218.356 313.107 218.66 313.301 218.991 313.467H220.649C221.81 312.775 222.998 312.112 224.159 311.448L224.187 311.503Z",
    fill: "#B4945F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.591 309.568V312.997L203.846 306.194V302.793L215.591 309.568Z",
    fill: "#D98274"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.591 309.568V310.508L203.846 303.733V302.793L215.591 309.568Z",
    fill: "#A24B5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.583 305.53L215.591 309.567V312.996L222.583 308.931V305.53Z",
    fill: "url(#paint97_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.522 303.872L215.591 308.462L202.906 301.134L210.837 296.544L223.522 303.872Z",
    fill: "#F3A382"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.522 303.871L219.128 306.415L212.412 302.544H210.948L209.51 301.714L210.229 301.299L209.262 300.719L213.656 298.175L223.522 303.871Z",
    fill: "#A24B5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.671 303.871L210.838 297.622L204.786 301.134L215.591 307.383L221.671 303.871Z",
    fill: "url(#paint98_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.838 297.622L204.786 301.134L214.32 306.637L210.838 297.622Z",
    fill: "url(#paint99_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.587 301.577L215.591 307.383L220.842 304.342L210.838 298.562L205.587 301.577Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.83 306.083L220.842 304.341L213.187 299.917L210.202 301.659L211.169 302.212L210.451 302.655L211.888 303.484H213.353L217.83 306.083Z",
    fill: "#464D48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.591 308.462V310.121L202.906 302.793V301.134L215.591 308.462Z",
    fill: "#D98274"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.523 303.871L215.591 308.461V310.12L223.523 305.53V303.871Z",
    fill: "#A24B5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.587 301.577L206.057 301.853L211.308 298.839L210.838 298.562L205.587 301.577Z",
    fill: "#464D48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.888 303.484V297.871L213.353 297.041V302.654L211.888 303.484Z",
    fill: "url(#paint100_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.889 303.484V297.871L210.452 297.041V302.654L211.889 303.484Z",
    fill: "#A17F63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.889 302.101V297.871L210.452 297.041V301.244L211.889 302.101Z",
    fill: "url(#paint101_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.518 296.046L217.387 300.139L204.592 292.756L211.722 288.636L224.518 296.046Z",
    fill: "#E9E691"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.592 292.755L217.387 300.138V303.511L204.592 296.101V292.755Z",
    fill: "#B3AA6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.518 296.046L217.388 300.138V303.512L224.518 299.392V296.046Z",
    fill: "url(#paint102_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.737 290.599L220.455 297.373V300.719L208.737 293.945V290.599Z",
    fill: "#B3AA6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.125 294.691L220.455 297.373L208.737 290.598L213.38 287.916L225.125 294.691Z",
    fill: "#E9E691"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.146 292.396L225.126 294.692L222.113 296.434L221.644 296.157L220.234 296.987H219.764L213.795 293.53L218.438 290.82L221.146 292.396Z",
    fill: "url(#paint103_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.633 291.76L218.161 294.913L209.788 290.046L215.232 286.894L223.633 291.76Z",
    fill: "#E9E691"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.764 296.986L210.588 291.649L211.39 293.723L219.764 298.59V296.986Z",
    fill: "url(#paint104_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.788 290.046L218.161 294.913V296.987L209.788 292.12V290.046Z",
    fill: "#B3AA6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.126 294.69L220.455 297.373V300.719L225.126 298.036V294.69Z",
    fill: "url(#paint105_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.633 291.76L218.161 294.912V296.986L223.633 293.834V291.76Z",
    fill: "url(#paint106_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.258 291.207L222.195 293.53L213.601 288.58L217.663 286.229L226.258 291.207Z",
    fill: "#E9E691"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.601 288.58L222.195 293.53V295.604L213.601 290.654V288.58Z",
    fill: "#B3AA6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.259 291.207L222.196 293.53V295.604L226.259 293.281V291.207Z",
    fill: "url(#paint107_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-253-outside-1_1515_6838",
    maskUnits: "userSpaceOnUse",
    x: 245.626,
    y: 122.677,
    width: 87,
    height: 112,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 245.626,
    y: 122.677,
    width: 87,
    height: 112
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.147 126.677L249.627 127.562L249.626 127.561V185.547L327.782 230.703V230.703L327.782 230.703L329.302 229.818V171.832L329.302 171.832L329.302 171.832L251.147 126.677Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tv",
    className: "tv"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.147 126.677L249.627 127.562L249.626 127.561V185.547L327.782 230.703V230.703L327.782 230.703L329.302 229.818V171.832L329.302 171.832L329.302 171.832L251.147 126.677Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tv-border",
    className: "border hide",
    d: "M249.627 127.562L248.101 130.203C249.048 130.75 250.216 130.748 251.161 130.198L249.627 127.562ZM251.147 126.677L252.673 124.036C251.725 123.488 250.558 123.49 249.612 124.041L251.147 126.677ZM249.626 127.561L251.152 124.92C250.209 124.375 249.046 124.375 248.102 124.919C247.158 125.464 246.576 126.471 246.576 127.561H249.626ZM249.626 185.547H246.576C246.576 186.637 247.157 187.643 248.1 188.188L249.626 185.547ZM327.782 230.703H330.832C330.832 229.613 330.251 228.606 329.308 228.061L327.782 230.703ZM327.782 230.703H324.731C324.731 231.603 325.129 232.458 325.818 233.037C326.507 233.617 327.417 233.862 328.304 233.708L327.782 230.703ZM327.782 230.703L328.305 233.708C328.661 233.646 329.004 233.521 329.317 233.339L327.782 230.703ZM329.302 229.818L330.837 232.454C331.775 231.908 332.352 230.904 332.352 229.818H329.302ZM329.302 171.832L327.761 169.2C326.826 169.747 326.251 170.749 326.251 171.832H329.302ZM329.302 171.832L330.843 174.465C331.746 173.937 332.315 172.982 332.351 171.936C332.386 170.891 331.884 169.9 331.019 169.311L329.302 171.832ZM329.302 171.832L331.018 169.311C330.956 169.268 330.893 169.228 330.828 169.191L329.302 171.832ZM251.161 130.198L252.681 129.313L249.612 124.041L248.092 124.925L251.161 130.198ZM248.101 130.203L248.101 130.203L251.153 124.92L251.152 124.92L248.101 130.203ZM252.677 185.547V127.561H246.576V185.547H252.677ZM329.308 228.061L251.152 182.906L248.1 188.188L326.256 233.344L329.308 228.061ZM330.832 230.703V230.703H324.731V230.703H330.832ZM327.259 227.697L327.259 227.697L328.304 233.708L328.305 233.708L327.259 227.697ZM327.767 227.182L326.247 228.067L329.317 233.339L330.837 232.454L327.767 227.182ZM326.251 171.832V229.818H332.352V171.832H326.251ZM327.762 169.199L327.761 169.2L330.842 174.465L330.843 174.465L327.762 169.199ZM327.585 174.353L327.585 174.354L331.019 169.311L331.018 169.311L327.585 174.353ZM249.621 129.318L327.776 174.473L330.828 169.191L252.673 124.036L249.621 129.318Z",
    fill: "white",
    mask: "url(#path-253-outside-1_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.782 230.703L329.302 229.818V171.832L327.782 172.717V230.703Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.626 127.562L251.146 126.677L329.302 171.832L327.782 172.717L249.626 127.562Z",
    fill: "#A9A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.626 185.547L327.782 230.703V172.717L249.626 127.562V185.547Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.202 184.635V130.271L326.207 173.63V227.993L251.202 184.635Z",
    fill: "#4B4B3C"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.239 171.004L370.823 183.475V150.68L367.811 142.909L346.227 130.438V163.234L349.239 171.004Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.312 177.667L365.379 175.925V143.103L362.312 144.872V177.667Z",
    fill: "url(#paint108_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.728 132.401L343.795 130.659L365.379 143.103L362.311 144.872L340.728 132.401Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.728 165.196L362.311 177.667V144.872L340.728 132.401V165.196Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.303 164.311V135.139L360.764 145.785V174.957L342.303 164.311Z",
    fill: "#A24B5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.764 147.085V173.188L345.343 164.312V138.181L360.764 147.085Z",
    fill: "#D98274"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.303 164.312L343.823 163.427L360.764 173.188V174.958L342.303 164.312Z",
    fill: "url(#paint109_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.343 164.312L360.764 173.188V174.957L342.303 164.312H345.343Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.303 164.311L343.823 163.427V135.996L342.303 135.139V164.311Z",
    fill: "url(#paint110_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.468 253.628L372.399 264.55V231.755L369.387 223.985L350.456 213.062L350.484 245.858L353.468 253.628Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.347 258.55L369.387 256.78V223.985L366.347 225.755V258.55Z",
    fill: "url(#paint111_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.416 214.832L350.456 213.062L369.387 223.985L366.347 225.755L347.416 214.832Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.416 247.627L366.347 258.55V225.754L347.416 214.832V247.627Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.991 246.715V217.542L364.772 226.639V255.84L348.991 246.715Z",
    fill: "#8A824C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.772 227.939V254.07L352.031 246.715V220.584L364.772 227.939Z",
    fill: "#C5BF76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.991 246.715L350.511 245.83L364.772 254.07V255.812L348.991 246.715Z",
    fill: "url(#paint112_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.031 246.715L364.772 254.07V255.812L348.991 246.715H352.031Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.991 246.715L350.511 245.83V218.427L348.991 217.542V246.715Z",
    fill: "url(#paint113_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.067 209.275L372.4 218.704V196.914L369.387 189.144L353.054 179.715V201.505L356.067 209.275Z",
    fill: "#48A935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.347 212.704L369.387 210.934V189.145L366.347 190.914V212.704Z",
    fill: "url(#paint114_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.986 181.457L353.054 179.715L369.387 189.144L366.347 190.914L349.986 181.457Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.986 203.274L366.347 212.704V190.914L349.986 181.457V203.274Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.561 202.362V184.194L364.771 191.799V209.994L351.561 202.362Z",
    fill: "#A98A68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.771 193.099V208.224L354.601 202.362V187.236L364.771 193.099Z",
    fill: "#E6D2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.561 202.361L353.081 201.477L364.771 208.224V209.993L351.561 202.361Z",
    fill: "url(#paint115_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.601 202.361L364.771 208.224V209.993L351.561 202.361H354.601Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.561 202.362L353.081 201.477V185.052L351.561 184.194V202.362Z",
    fill: "url(#paint116_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.205 258.384L322.101 271.712L221.947 213.865L245.051 200.509L345.205 258.384Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.1 298.645V271.712L221.919 213.837V240.77L322.1 298.645Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.101 299.834V296.378L225.733 240.715V244.171L322.101 299.834Z",
    fill: "#6E5733"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.101 299.835V296.378L341.281 285.317V288.746L322.101 299.835Z",
    fill: "url(#paint117_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.1 298.645V275.224C285.178 253.877 261.881 240.438 221.919 217.349V240.77L254.668 259.684L256.63 260.817L287.417 278.597L322.128 298.645H322.1ZM287.389 276.33L256.602 258.55V239.664L287.389 257.444V276.33Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.101 298.646V271.713L345.205 258.385V285.318L322.101 298.646Z",
    fill: "url(#paint118_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.493 227.442L234.853 221.303V221.331L221.919 213.837V221.275L238.584 230.898L248.312 256.034L258.952 262.172L249.196 237.037L322.1 279.151V271.712L245.493 227.469V227.442Z",
    fill: "url(#paint119_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.39 276.33V257.444L256.63 239.664V258.55L287.39 276.33Z",
    fill: "url(#paint120_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.963 249.121L256.63 239.664V258.55L272.963 249.121Z",
    fill: "url(#paint121_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.167 259.519L322.101 273.981L218.023 213.866L243.089 199.376L347.167 259.519Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.53 228.576L232.89 222.438L249.804 212.704H220.04L223.743 210.575L233.996 204.63L243.088 199.376L248.864 202.722V204.077L248.477 204.63H252.181L268.569 214.114L243.53 228.576Z",
    fill: "#C5A16E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.101 277.492V273.98L218.023 213.865V217.377L322.101 277.492Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.66 227L245.272 233.139L243.531 228.576L232.891 222.438L234.66 227Z",
    fill: "#A18654"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.101 277.491V273.979L347.167 259.518V263.029L322.101 277.491Z",
    fill: "#AB8D59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.39 276.33V266.403L273.848 258.55H259.007L257.819 259.241L287.39 276.33Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.706 239.664L254.89 245.277V258.44V259.656L253.812 259.048L251.656 253.435V252.218L252.706 252.826L252.762 252.992V243.176L251.656 240.272V239.056L252.706 239.664Z",
    fill: "url(#paint122_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.707 239.664L251.656 239.056L249.473 240.328L250.523 240.936L252.707 239.664Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.523 255.288L249.473 254.679V240.328L250.523 240.936V255.288Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.707 252.799L251.657 252.19L250.523 252.854L251.574 253.462L252.707 252.799Z",
    fill: "url(#paint123_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.707 240.881V239.664L250.523 240.936V254.071V255.287L252.707 254.043V252.799L251.574 253.462V241.544L252.707 240.881Z",
    fill: "url(#paint124_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.179 258.771L269.509 261.454L282.36 271.132H286.229L287.389 270.468V266.403L274.179 258.771Z",
    fill: "url(#paint125_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.364 262.588L294.547 268.201V281.363V282.58L293.497 281.972L291.314 276.358V275.142L292.364 275.75L292.447 275.916V266.1L291.314 263.196V261.979L292.364 262.588Z",
    fill: "url(#paint126_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.364 262.588L291.313 261.979L289.158 263.251L290.208 263.86L292.364 262.588Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.208 278.212L289.158 277.603V263.252L290.208 263.86V278.212Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.364 275.723L291.314 275.114L290.208 275.778L291.259 276.386L292.364 275.723Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.208 275.777L291.259 276.386L292.309 275.777H290.208Z",
    fill: "url(#paint127_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.364 263.805V262.588L290.208 263.86V276.994V278.211L292.364 276.939V275.723L291.259 276.386V264.468L292.364 263.805Z",
    fill: "url(#paint128_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.523 255.288L249.473 254.68V244.614L250.523 247.324V255.288Z",
    fill: "url(#paint129_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.36 271.131L265.64 261.453V257.582L282.36 267.26V271.131Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.639 251.25L265.64 257.582L282.36 267.26L287.389 264.357V257.444L276.639 251.25Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.31 254.9L265.64 257.583L282.36 267.261L287.058 264.551L270.31 254.9Z",
    fill: "#A9A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.389 268.228L282.359 271.131V267.26L287.389 264.356V268.228Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.84 269.251L272.853 264.633V262.78L280.84 267.398V269.251Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.878 260.237L268.072 260.347L268.265 260.541L268.404 260.79L268.486 261.066V261.315L268.404 261.481L268.265 261.564H268.072L267.878 261.426L267.685 261.232L267.547 260.983L267.464 260.707V260.458L267.547 260.292L267.685 260.209H267.878V260.237ZM269.343 261.066L269.537 261.177L269.73 261.37L269.868 261.619L269.951 261.896V262.145L269.868 262.311L269.73 262.393H269.537L269.343 262.255L269.15 262.062L269.011 261.813L268.929 261.536V261.287L269.011 261.122L269.15 261.039H269.343V261.066ZM270.78 261.896L270.974 262.006L271.167 262.2L271.305 262.449L271.388 262.725V262.974L271.305 263.14L271.167 263.223H270.974L270.78 263.085L270.587 262.891L270.449 262.642L270.366 262.366V262.117L270.449 261.951L270.587 261.868H270.78V261.896Z",
    fill: "#5A5849"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.731 318.057L228.469 316.177L217.885 322.288L219.985 324.168H221.118L231.731 318.057Z",
    fill: "url(#paint130_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.985 324.167L216.751 322.287V321.153L219.985 323.034V324.167Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.597 316.923L227.336 315.043L216.751 321.154L219.985 323.034L230.597 316.923Z",
    fill: "#A9A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.597 318.057L219.984 324.168V323.034L230.597 316.923V318.057Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.289 319.882L220.206 319.826H220.068L219.93 319.799H219.791L219.709 319.882L219.653 319.964V320.047L219.709 320.13L219.791 320.186H219.93L220.068 320.213H220.206L220.317 320.13L220.372 320.047V319.964L220.317 319.882H220.289ZM220.98 320.269L221.035 320.352V320.435L220.98 320.518L220.897 320.573H220.759L220.621 320.6H220.482L220.399 320.518L220.344 320.435V320.352L220.399 320.269L220.482 320.213H220.621L220.759 320.186H220.897L220.98 320.269ZM221.643 320.656L221.56 320.6H221.422L221.284 320.573H221.146L221.063 320.656L221.007 320.739V320.822L221.063 320.905L221.146 320.96H221.284L221.422 320.988H221.56L221.643 320.905L221.698 320.822V320.739L221.643 320.656ZM222.334 321.043L222.389 321.126V321.209L222.334 321.292L222.223 321.347H222.085L221.947 321.375H221.809L221.726 321.292L221.671 321.209V321.126L221.726 321.043L221.809 320.988H221.947L222.085 320.96H222.223L222.306 321.043H222.334ZM221.146 319.384L221.063 319.329H220.925L220.786 319.301H220.648L220.565 319.384L220.51 319.467V319.55L220.565 319.633L220.648 319.688H220.786L220.925 319.716H221.063L221.146 319.633L221.201 319.55V319.467L221.146 319.384ZM221.809 319.771L221.864 319.854V319.937L221.809 320.02L221.726 320.075H221.588L221.45 320.103H221.311L221.229 320.02L221.173 319.937V319.854L221.229 319.771L221.311 319.716H221.45L221.588 319.688H221.726L221.837 319.771H221.809ZM222.5 320.158L222.417 320.103H222.279L222.141 320.075H222.002L221.919 320.158L221.864 320.241V320.324L221.919 320.407L222.002 320.462H222.141L222.279 320.49H222.417L222.527 320.407L222.583 320.324V320.241L222.527 320.158H222.5ZM223.163 320.545L223.218 320.628V320.711L223.163 320.794L223.08 320.849H222.942L222.804 320.877H222.666L222.583 320.794L222.527 320.711V320.628L222.583 320.545L222.666 320.49H222.804L222.942 320.462H223.08L223.163 320.545ZM221.975 318.886L221.864 318.831H221.726L221.588 318.803H221.45L221.367 318.886L221.311 318.969V319.052L221.367 319.135L221.45 319.19H221.588L221.726 319.218H221.864L221.975 319.135L222.03 319.052V318.969L221.975 318.886ZM222.666 319.301L222.721 319.384V319.467L222.666 319.55L222.555 319.605H222.417L222.279 319.633H222.141L222.058 319.55L222.002 319.467V319.384L222.058 319.301L222.141 319.246H222.279L222.417 319.218H222.555L222.638 319.301H222.666ZM223.329 319.688L223.246 319.633H223.108L222.97 319.605H222.831L222.749 319.688L222.693 319.771V319.854L222.749 319.937L222.831 319.992H222.97L223.108 320.02H223.246L223.329 319.937L223.384 319.854V319.771L223.329 319.688ZM224.02 320.075L224.075 320.158V320.241L224.02 320.324L223.909 320.379H223.771L223.633 320.407H223.495L223.412 320.324L223.357 320.241V320.158L223.412 320.075L223.495 320.02H223.633L223.771 319.992H223.909L224.02 320.075ZM222.831 318.416L222.749 318.361H222.61L222.472 318.333H222.334L222.251 318.416L222.196 318.499V318.582L222.251 318.665L222.362 318.72H222.5L222.638 318.748H222.776L222.859 318.665L222.914 318.582V318.499L222.859 318.416H222.831ZM223.495 318.803L223.55 318.886V318.969L223.495 319.052L223.412 319.107H223.274L223.135 319.135H222.997L222.914 319.052L222.859 318.969V318.886L222.914 318.803L222.997 318.748H223.135L223.274 318.72H223.412L223.495 318.803ZM224.186 319.19L224.075 319.135H223.937L223.799 319.107H223.661L223.578 319.19L223.522 319.273V319.356L223.578 319.439L223.661 319.494H223.799L223.937 319.522H224.075L224.186 319.439L224.241 319.356V319.273L224.186 319.19ZM224.849 319.577L224.904 319.66V319.743L224.849 319.826L224.766 319.882H224.628L224.49 319.909H224.351L224.241 319.826L224.186 319.743V319.66L224.241 319.577L224.324 319.522H224.462L224.6 319.494H224.738L224.821 319.577H224.849ZM226.369 316.37L226.286 316.314H226.148L226.01 316.287H225.871L225.789 316.37L225.733 316.453V316.536L225.789 316.619L225.871 316.674H226.01L226.148 316.702H226.286L226.397 316.619L226.452 316.536V316.453L226.397 316.37H226.369ZM227.032 316.757L227.087 316.84V316.923L227.032 317.006L226.949 317.061H226.811L226.673 317.089H226.535L226.452 317.006L226.397 316.923V316.84L226.452 316.757L226.535 316.702H226.673L226.811 316.674H226.949L227.032 316.757ZM227.723 317.144L227.64 317.089H227.502L227.364 317.061H227.226L227.143 317.144L227.087 317.227V317.31L227.143 317.393L227.226 317.448H227.364L227.502 317.476H227.64L227.723 317.393L227.778 317.31V317.227L227.723 317.144ZM228.386 317.531L228.442 317.614V317.697L228.386 317.78L228.276 317.835H228.138L227.999 317.863H227.861L227.778 317.78L227.723 317.697V317.614L227.778 317.531L227.861 317.476H227.999L228.138 317.448H228.276L228.359 317.531H228.386ZM227.198 315.872L227.115 315.817H226.977L226.839 315.789H226.701L226.618 315.872L226.562 315.955V316.038L226.618 316.121L226.701 316.176H226.839L226.977 316.204H227.115L227.198 316.121L227.253 316.038V315.955L227.198 315.872ZM227.889 316.287L227.944 316.37V316.453L227.889 316.536L227.806 316.591H227.668L227.53 316.619H227.391L227.309 316.536L227.253 316.453V316.37L227.309 316.287L227.391 316.232H227.53L227.668 316.204H227.806L227.917 316.287H227.889ZM228.552 316.674L228.469 316.619H228.331L228.193 316.591H228.055L227.972 316.674L227.917 316.757V316.84L227.972 316.923L228.055 316.978H228.193L228.331 317.006H228.469L228.58 316.923L228.635 316.84V316.757L228.58 316.674H228.552ZM229.215 317.061L229.271 317.144V317.227L229.215 317.31L229.133 317.365H228.994L228.856 317.393H228.718L228.635 317.31L228.58 317.227V317.144L228.635 317.061L228.718 317.006H228.856L228.994 316.978H229.133L229.215 317.061ZM226.728 317.531L226.286 317.255L225.678 317.116H225.042L224.434 317.255L223.992 317.503L223.743 317.835V318.222L223.992 318.554L224.434 318.803L225.042 318.941H225.678L226.258 318.803L226.728 318.527L226.977 318.195V317.808L226.728 317.476V317.531ZM226.203 317.752L226.341 317.946V318.167L226.203 318.361L225.927 318.527L225.567 318.61H225.181L224.821 318.527L224.545 318.361L224.407 318.167V317.946L224.545 317.752L224.821 317.586L225.181 317.503H225.567L225.927 317.586L226.203 317.752ZM225.706 317.946L225.761 318.029V318.112L225.706 318.195L225.595 318.25H225.457L225.291 318.278H225.153L225.042 318.167L224.987 318.084V318.001L225.042 317.918L225.153 317.863H225.291L225.457 317.835H225.595L225.706 317.946Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.343 80.0295V57.6592L240.021 80.0295H231.343Z",
    fill: "url(#paint131_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.292 116.199V111.885L184.334 94.6025V98.9162L214.292 116.199Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.391 104.309L214.292 111.885L184.334 94.603L197.434 87.0264L227.391 104.309Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.391 104.309L214.291 111.885L206.636 107.461L219.735 99.8845L227.391 104.309ZM192.154 99.1102L184.361 94.603L197.46 87.0264L218.381 99.1102H192.182H192.154Z",
    fill: "url(#paint132_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.292 116.199V111.885L227.392 104.309V108.622L214.292 116.199Z",
    fill: "url(#paint133_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.155 103.423V99.1098L184.334 94.6025V98.9162L192.155 103.423Z",
    fill: "url(#paint134_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.292 116.199V111.885L206.609 107.461V111.775L214.292 116.199Z",
    fill: "#AB8D59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.94 92.5283L217.498 98.6117L214.264 100.492H199.092L196.19 98.7223L206.94 92.5283Z",
    fill: "url(#paint135_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.818 75.3846L200.778 73.6426L189.944 79.8919L192.984 81.634L203.818 75.3846Z",
    fill: "url(#paint136_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.885 76.0207L203.817 74.251L192.984 80.5003L196.052 82.27L206.885 76.0207Z",
    fill: "url(#paint137_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.858 92.4734L196.052 98.7227V82.2698L206.858 76.0205V92.4734Z",
    fill: "url(#paint138_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.092 100.492L195.278 98.2799L196.052 83.7627L199.092 85.5324V100.492Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.926 79.2834L206.858 77.5137L196.052 83.763L199.092 85.5327L209.926 79.2834Z",
    fill: "url(#paint139_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.688 84.1504L199.092 85.533L201.496 84.1504H196.688Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.925 94.2429L199.092 100.492V85.5325L209.925 79.2832V94.2429Z",
    fill: "url(#paint140_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.406 131.933V127.619L184.334 60.5908V64.9045L300.406 131.933Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.155 69.4118V65.0981L184.334 60.5908V64.9045L192.155 69.4118Z",
    fill: "url(#paint141_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.506 120.069L300.406 127.618L184.334 60.5903L197.434 53.0137L313.506 120.069Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.155 65.0975L184.334 60.5903L197.434 53.0137L218.354 65.0975H192.155Z",
    fill: "url(#paint142_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.407 131.932V127.618L313.506 120.069V124.355L300.407 131.932Z",
    fill: "#AB8D59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.292 150.209V145.896L184.334 128.613V132.927L214.292 150.209Z",
    fill: "#D8B984"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.391 138.32L214.292 145.896L184.334 128.614L197.434 121.037L227.391 138.32Z",
    fill: "#FADFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.155 133.121L184.334 128.614L197.434 121.037L218.354 133.121H192.155Z",
    fill: "url(#paint143_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.292 150.21V145.896L227.392 138.319V142.633L214.292 150.21Z",
    fill: "url(#paint144_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.155 137.434V133.121L184.334 128.613V132.927L192.155 137.434Z",
    fill: "url(#paint145_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.386 70.877L238.943 76.988L235.71 78.8683H220.676L217.608 77.0986L228.386 70.877Z",
    fill: "url(#paint146_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.441 67.8352L198.401 66.0654V48.0088L201.441 49.7785V67.8352Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.274 43.5295L209.234 41.7598L198.401 48.0091L201.441 49.7788L212.274 43.5295Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.274 61.5859L201.441 67.8353V49.7786L212.274 43.5293V61.5859Z",
    fill: "url(#paint147_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.509 69.6045L201.441 67.8347V52.5156L204.509 54.2853V69.6045Z",
    fill: "#F6CE6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.342 48.0363L212.274 46.2666L201.441 52.5159L204.509 54.2856L215.342 48.0363Z",
    fill: "#FEDE8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.656 47.0685L212.274 46.2666L201.441 52.5159H204.205L213.656 47.0685Z",
    fill: "#B87D34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.342 63.3562L204.509 69.6055V54.2864L215.342 48.0371V63.3562Z",
    fill: "#B68850"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.076 46.71L203.016 52.5168L204.508 53.3741L214.54 47.5672L213.076 46.71Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.076 46.71L203.016 52.5168H204.204L213.656 47.0694L213.076 46.71Z",
    fill: "url(#paint148_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.549 71.3755L204.509 69.6058V51.5215L207.549 53.2912V71.3755Z",
    fill: "url(#paint149_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.382 47.0412L215.342 45.2715L204.509 51.5208L207.549 53.2905L218.382 47.0412Z",
    fill: "#F7F1E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.382 65.0977L207.548 71.3746V53.2903L218.382 47.041V65.0977Z",
    fill: "url(#paint150_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.549 71.3755L204.509 69.6058V51.5215L207.549 53.2912V71.3755Z",
    fill: "#F7EACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.842 72.674L207.548 71.3743V53.29L209.842 54.6173V72.674Z",
    fill: "#D7636C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.676 48.3683L218.382 47.041L207.548 53.2903L209.842 54.6176L220.676 48.3683Z",
    fill: "#ED838A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.156 47.4834L209.124 53.2903L209.843 53.7051L219.875 47.8982L219.156 47.4834Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.116 45.7412L206.057 51.5204L207.549 52.3777L217.609 46.5984L216.116 45.7412Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.675 66.4258L209.842 72.6751V54.6185L220.675 48.3691V66.4258Z",
    fill: "url(#paint151_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.389 73.5866L209.842 72.6741V52.4883L211.389 53.3731V73.5866Z",
    fill: "#F6CE6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.223 47.1241L220.675 46.2393L209.842 52.4886L211.389 53.3734L222.223 47.1241Z",
    fill: "#FEDE8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.224 67.3099L211.39 73.5868V53.3733L222.224 47.124V67.3099Z",
    fill: "url(#paint152_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.43 75.3288L211.39 73.5867V58.2676L214.43 60.0096V75.3288Z",
    fill: "#7FB9DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.264 53.7609L222.224 51.9912L211.39 58.2682L214.43 60.0102L225.264 53.7609Z",
    fill: "#B1D8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.656 53.4015L222.224 51.9912L211.39 58.2682H216.254L224.656 53.4015Z",
    fill: "url(#paint153_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.264 69.0799L214.43 75.3292V60.0101L225.264 53.7607V69.0799Z",
    fill: "#146987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.997 52.4609L212.938 58.2678L214.43 59.0974L224.489 53.3181L222.997 52.4609Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.997 52.4609L212.938 58.2678H215.922L224.489 53.3181L222.997 52.4609Z",
    fill: "url(#paint154_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.47 77.0995L214.43 75.3298V58.877L217.47 60.6467V77.0995Z",
    fill: "#A0B434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.304 54.369L225.264 52.627L214.43 58.8763L217.47 60.646L228.304 54.369Z",
    fill: "#B0C238"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.304 70.8496L217.47 77.099V60.6461L228.304 54.3691V70.8496Z",
    fill: "#647926"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.037 53.0693L216.005 58.8762L217.47 59.7334L227.53 53.9265L226.037 53.0693Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.538 78.8671L217.471 77.0973V62.1377L220.538 63.9074V78.8671Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.344 57.6584L228.304 55.8887L217.471 62.138L220.538 63.9077L231.344 57.6584Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.304 55.8887L217.471 62.138H218.991L229.05 56.3311L228.304 55.8887Z",
    fill: "url(#paint155_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.344 72.6178L220.538 78.8672V63.9075L231.344 57.6582V72.6178Z",
    fill: "url(#paint156_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.121 268.477L304.027 254.402L321.272 248.65H323.621L328.236 253.268L338.71 257.444L335.283 260.319L337.715 262.725L320.47 268.477H318.121Z",
    fill: "#B19667"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.121 266.127V268.477L304.027 254.402V252.052L318.121 266.127Z",
    fill: "#B8CCD9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.122 266.127V268.477L335.367 262.725V260.375L318.122 266.127Z",
    fill: "url(#paint157_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.366 260.375L318.121 266.126L304.027 252.051L321.272 246.3L335.366 260.375Z",
    fill: "#CCDFEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.551 263.306H323.4L321.604 262.587V252.577H327.546L328.016 253.047L332.935 257.969L326.551 263.306Z",
    fill: "#436775"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.239 251.968L323.4 260.181L310.604 255.065L320.443 246.853L333.239 251.968Z",
    fill: "#F9F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.4 263.306V260.181L310.604 255.065V258.19L323.4 263.306Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.4 263.306V260.181L333.239 251.969V255.093L323.4 263.306Z",
    fill: "url(#paint158_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.884 239.94H185.108V241.489H190.884V239.94Z",
    fill: "url(#paint159_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.108 239.913L179.774 238.641V240.189L185.108 241.461V239.913Z",
    fill: "url(#paint160_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.684 236.29L179.774 238.64V240.189L175.684 237.839V236.29Z",
    fill: "url(#paint161_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.685 236.29L173.474 233.193V234.742L175.685 237.839V236.29Z",
    fill: "url(#paint162_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.884 239.913L196.218 238.641V240.189L190.884 241.461V239.913Z",
    fill: "url(#paint163_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.308 236.29L196.218 238.64V240.189L200.308 237.839V236.29Z",
    fill: "url(#paint164_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.309 236.29L202.519 233.193V234.742L200.309 237.839V236.29Z",
    fill: "url(#paint165_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.945 95.2107V79.8916L192.985 81.6337V80.4999L196.052 82.2697V83.7629L196.688 84.15V99.1096L196.052 98.7225L192.985 96.9804L189.945 95.2107Z",
    fill: "url(#paint166_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.42 243.48L318.121 244.226H313.699L262.683 212.206L263.982 211.459L319.42 243.48Z",
    fill: "url(#paint167_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.308 236.29L196.218 238.641L190.884 239.94L185.109 239.913L179.775 238.641L175.685 236.29L173.474 233.193V229.847L175.685 226.778L179.775 224.4L185.109 223.128H190.884L196.218 224.4L200.308 226.778L202.519 229.847V233.193L200.308 236.29Z",
    fill: "#F7F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.308 236.29L196.218 238.641L190.884 239.94L185.109 239.913L179.775 238.641L175.685 236.29L173.474 233.193V229.847L175.685 226.778L179.775 224.4L185.109 223.128H190.884L196.218 224.4L200.308 226.778L202.519 229.847V230.594V232.198V232.447H202.077L200.308 233.47H202.326L200.308 236.29Z",
    fill: "url(#paint168_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.364 232.059L188.894 232.308L188.314 232.447H187.679L187.098 232.308L186.656 232.059L186.407 231.728V180.931L186.656 180.572L187.098 180.323L187.679 180.185H188.314L188.894 180.323L189.364 180.572L189.585 180.931V231.7L189.364 232.059Z",
    fill: "url(#paint169_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.314 182.037H187.679V232.474H188.314V182.037Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.679 182.037L187.098 181.871V218.372L187.679 218.51V182.037Z",
    fill: "url(#paint170_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.656 181.623L187.098 181.872V218.372L186.656 218.096V181.623Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.656 181.623L186.407 181.291V217.764L186.656 218.096V181.623Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.314 182.037L188.895 181.871V232.308L188.314 232.446V182.037Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.364 181.623L188.895 181.872V232.309L189.364 232.06V181.623Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.365 181.623L189.586 181.291V231.7L189.365 232.06V181.623Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.878 152.505V155.298L174.911 173.686L173.474 180.765V177.419L175.878 152.505Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.364 179.604L188.894 179.88L188.314 180.019H187.679L187.098 179.88L186.656 179.604L186.407 179.272V178.913L186.656 178.581L187.098 178.304L187.679 178.166H188.314L188.894 178.304L189.364 178.581L189.585 178.913V179.272L189.364 179.604Z",
    fill: "#F7F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.263 157.869L194.864 159.833L190.415 160.883H185.578L181.129 159.833L177.73 157.869L175.878 155.298V152.505L177.73 149.933L181.129 147.97L185.578 146.892H190.415L194.864 147.97L198.263 149.933L200.115 152.505V155.298L198.263 157.869Z",
    fill: "#F7F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.73 157.869L175.878 155.298L173.474 180.765L175.685 183.862L177.951 170.036L177.73 157.869Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.415 160.884L194.864 159.833L196.66 171.06L196.218 186.213L190.884 187.485L190.415 160.884Z",
    fill: "url(#paint171_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.264 157.869L194.864 159.832L196.218 186.212L200.309 183.862L200.64 170.838L198.264 157.869Z",
    fill: "url(#paint172_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.264 157.869L200.115 155.298V152.505L202.52 177.419V180.765L200.309 183.862L198.264 157.869Z",
    fill: "#BBB0A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.263 157.869L194.864 159.832L190.415 160.883H185.578L181.129 159.832L177.73 157.869L176.292 155.851H199.7L198.263 157.869Z",
    fill: "#CFC4BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.384 157.151L193.62 158.755L189.972 159.612H186.02L182.372 158.755L179.609 157.151L178.089 155.022V152.754L179.609 150.653L182.372 149.049L186.02 148.164H189.972L193.62 149.049L196.384 150.653L197.904 152.754V155.022L196.384 157.151Z",
    fill: "#C4B8B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.973 148.164L190.166 159.584L189.973 159.612H186.021L185.827 159.584L186.021 148.164H189.973Z",
    fill: "url(#paint173_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.62 149.049L189.972 148.164L190.055 154.22L193.62 158.755L194.007 158.506L193.62 149.049Z",
    fill: "url(#paint174_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.621 149.048L196.384 150.652L197.904 152.753V155.021L196.384 157.15L194.588 158.173L194.008 158.505L193.621 149.048Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.578 160.884H190.415L190.885 170.7V187.485H185.109L184.031 172.11L185.578 160.884Z",
    fill: "url(#paint175_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.578 160.884L181.129 159.833L179.774 171.972V186.213L185.108 187.485L185.578 160.884Z",
    fill: "url(#paint176_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.729 157.869L181.128 159.832L179.774 186.212L175.684 183.862L177.729 157.869Z",
    fill: "url(#paint177_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.729 157.869L176.292 155.851L173.86 181.318L175.684 183.862L177.951 170.036L177.729 157.869Z",
    fill: "url(#paint178_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.656 216.464L187.098 217.045L187.402 223.239L187.098 232.308L186.656 232.06L186.435 223.322L186.656 216.464Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.679 217.736L187.098 217.045V232.309L187.679 232.447V217.736Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.656 216.464L186.407 215.662V231.7L186.656 232.06V216.464Z",
    fill: "#B8ACA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.21 237.756L313.7 239.802V244.226L317.21 242.208V237.756Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.262 207.754L313.701 239.802V244.227L258.262 212.206V207.754Z",
    fill: "#716B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.262 207.754L262.85 210.409L265.061 216.132L258.262 212.206V207.754Z",
    fill: "#4B4B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.21 237.756L313.701 239.802L258.262 207.754L261.772 205.735L317.21 237.756Z",
    fill: "#A9A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.85 210.409L258.262 207.754L261.772 205.735L266.36 208.39L262.85 210.409Z",
    fill: "url(#paint179_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1515_6838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.351 328.512C291.168 332.429 300.188 334.941 304.848 333.86C308.667 332.969 310.157 332.023 312.541 332.158C322.266 332.645 325.408 322.974 315.819 322.218C306.934 321.543 302.681 321.867 295.231 321.948C289.353 322.002 285.831 324.973 288.378 328.512H288.351Z",
    fill: "url(#paint180_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.979 245.611C313.191 241.694 314.22 235.076 312.866 231.456C311.512 227.836 310.672 226 313.11 224.163C315.304 222.515 318.744 224.73 319.557 227.836C320.37 230.943 320.451 239.668 321.318 242.315C322.185 247.177 315.602 246.934 315.006 245.638L314.979 245.611Z",
    fill: "#2A8DCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.782 325.378C309.832 324.649 308.694 324.163 306.229 323.812C305.498 323.704 302.274 322.974 301.597 324.352C300.866 325.838 302.681 327.188 303.331 327.431C305.796 328.35 307.123 328.35 309.507 329.106C309.94 329.241 310.889 329.7 311.674 329.862C313.083 330.133 315.331 330.051 316.198 328.755C316.875 327.755 316.361 326.945 316.198 326C314.6 325.865 313.299 326 311.755 325.405L311.782 325.378Z",
    fill: "#5F6989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.279 326.054C316.036 325.324 316.063 324.163 315.25 323.325C314.112 322.164 312.379 321.083 310.428 320.894C309.29 320.786 307.611 322.272 305.769 322.38C304.956 322.434 302.518 322.245 301.868 323.136C301.597 323.514 301.543 323.704 301.489 323.974C301.435 324.244 301.407 324.244 301.462 324.433C301.787 325.648 302.112 326.027 303.493 326.621C305.227 327.377 307.096 327.62 309.426 328.026C309.859 328.107 312.026 328.62 313.11 328.62C313.814 328.62 315.575 328.458 316.09 327.485C316.361 326.999 316.55 326.756 316.306 326.027L316.279 326.054Z",
    fill: "#2E374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.954 327.108C302.275 326.378 300.974 325.946 298.861 325.568C298.238 325.46 294.879 323.758 294.419 325.352C293.958 326.945 294.988 328.431 296.423 329.133C298.292 330.025 299.972 329.944 302.058 330.43C302.437 330.511 303.466 331.105 304.117 331.186C305.281 331.348 307.178 331.321 307.99 330.565C309.128 329.485 308.803 327.783 307.503 327.324C306.284 326.891 305.309 327.621 303.981 327.054L303.954 327.108Z",
    fill: "#5F6989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.232 324.406C306.907 324.055 306.365 323.623 305.634 323.515C304.577 323.353 303.683 323.217 302.302 323.19C301.489 323.19 300.947 324.352 298.943 324.244C298.347 324.217 296.884 323.974 295.936 324.082C294.988 324.19 293.931 324.865 294.636 326.378C294.906 326.972 295.719 328.161 296.992 328.566C298.32 328.998 300.08 329.349 302.004 329.592C302.356 329.646 304.279 329.998 305.336 329.971C306.013 329.971 307.747 329.916 308.424 328.917C308.586 328.674 308.641 328.323 308.586 327.81C308.478 326.594 308.288 325.459 307.286 324.379L307.232 324.406Z",
    fill: "#2E374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.494 323.352C315.115 316.41 313.733 302.904 313.083 293.72C312.839 289.479 313.137 284.536 313.218 280.754C313.3 276.432 315.061 271.894 314.979 268.409C314.925 266.032 315.006 263.25 313.923 261.359C312.921 259.603 311.62 261.035 309.995 261.17C307.259 261.413 305.634 262.494 302.925 265.276C301.76 266.465 300.405 269.652 300.703 270.705C302.789 277.864 304.415 286.697 305.363 294.827C306.311 302.985 307.205 308.766 308.153 321.732C308.234 322.758 308.83 324.433 311.539 324.757C314.329 325.081 315.548 324.298 315.494 323.352Z",
    fill: "#3D4561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.929 278.296C305.634 274.19 307.611 272.38 308.099 269.085C308.64 265.492 308.424 263.196 308.37 259.657C304.604 260.954 295.963 260.36 293.064 263.682C292.252 264.627 293.471 280.727 293.85 283.563C294.283 286.994 294.961 291.397 295.638 294.773C297.453 303.903 300.974 314.6 300.839 323.649C300.622 324.946 301.814 326.269 303.06 326.486C304.387 326.702 306.013 326.837 307.259 326.188C307.746 325.945 307.99 325.405 307.936 324.892C306.88 314.951 305.742 304.849 304.577 294.854C303.873 290.154 304.171 282.564 304.902 278.296H304.929Z",
    fill: "#5F6989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.744 229.917C318.717 237.238 316.577 243.991 315.44 251.419C314.979 254.418 315.277 259.172 314.329 262.683C314.085 263.575 310.726 264.655 308.857 265.087C306.798 265.547 301.976 265.736 299.755 265.303C297.425 264.844 293.904 264.412 293.525 262.629C292.983 260.252 293.687 258.064 293.714 256.227C293.768 253.121 293.633 250.69 293.416 247.827C293.416 247.529 293.362 247.259 293.335 246.962C292.983 243.397 292.17 239.075 292.956 235.428C293.064 234.969 293.172 234.509 293.335 234.023C293.525 233.429 294.256 232.051 295.746 230.89C297.642 229.431 301.841 226.001 304.55 224.731C306.581 223.786 311.864 223.272 313.245 223.38C314.789 223.515 315.629 223.786 316.577 224.65C318.23 226.136 318.771 227.918 318.744 229.917Z",
    fill: "#4EA8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.696 244.503C296.504 249.608 294.608 255.74 293.714 256.226C293.823 249.257 292.441 238.074 293.227 234.428C293.687 233.833 294.392 233.347 294.933 233.212C296.017 232.942 298.157 233.644 298.536 235.913C298.915 238.182 298.59 240.748 297.696 244.53V244.503Z",
    fill: "#2A8DCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.752 218.14C308.098 218.113 305.443 218.113 302.761 218.194C303.168 220.139 303.005 223.732 303.411 225.298C303.818 226.865 304.414 226.379 305.822 226.649C307.529 226.946 310.861 227.216 310.915 223.867C310.915 223.056 310.834 219.41 310.752 218.167V218.14Z",
    fill: "#E8BEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.223 212.412C313.001 220.759 308.45 216.707 307.177 217.437C306.608 217.761 306.635 218.706 305.958 218.706C305.443 218.706 305.2 218.409 305.01 218.355C304.116 218.139 304.279 219.76 303.303 220.354C302.274 220.975 299.43 221.11 299.213 219.49C299.05 218.301 299.078 217.518 298.888 216.599C298.698 215.762 299.105 215.546 299.05 214.843C298.996 214.06 298.102 213.979 298.292 213.061C298.455 212.304 299.89 211.17 300.269 210.467C300.595 209.9 300.188 209.117 300.324 208.685C301.678 204.498 302.626 202.985 307.34 203.282C312.92 203.633 316.74 206.848 315.223 212.439V212.412Z",
    fill: "#F8D3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.198 208.388C315.547 206.605 314.599 204.741 312.026 203.931C308.179 202.688 304.658 203.202 304.008 202.256C302.734 200.446 300.838 203.796 301.949 206.146C302.518 207.335 304.414 208.091 304.576 208.28C304.522 208.307 304.441 208.307 304.387 208.361C302.599 210.009 304.116 210.954 303.683 212.143C303.357 213.034 303.168 213.682 303.655 214.304C304.197 215.033 305.416 214.817 305.416 214.817C305.416 214.817 304.739 214.196 304.766 213.358C304.793 212.575 305.362 212.035 306.337 212.359C307.014 212.575 307.963 213.412 306.635 216.843C305.254 220.463 311.159 221.813 312.297 220.787C313.245 219.922 312.703 220.192 313.299 219.139C314.328 217.302 314.328 216.492 315.331 214.682C316.36 212.818 316.794 210.144 316.171 208.415L316.198 208.388Z",
    fill: "#2E374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.413 266.195C304.848 266.276 306.392 266.195 307.449 266.06C310.185 265.763 312.352 265.006 314.627 263.683C314.79 263.575 314.79 262.629 314.763 262.332C314.709 261.63 314.654 261.549 314.573 261.549C312.325 263.116 310.727 263.926 307.124 264.196C303.223 264.493 297.074 264.034 293.335 261.657C293.092 261.765 293.092 262.359 293.037 262.71C293.01 263.007 293.037 263.359 293.037 263.656C296.18 265.195 299.945 265.979 303.358 266.168L303.413 266.195Z",
    fill: "#2E374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.674 265.385C311.674 265.385 311.837 265.385 311.918 265.385C312.081 265.358 312.189 265.277 312.189 265.088C312.162 264.493 312.108 263.818 312.081 263.197C312.081 263.008 311.945 262.954 311.783 262.927C311.729 262.927 311.62 262.927 311.539 262.927C311.376 262.954 311.268 263.035 311.268 263.224C311.295 263.818 311.349 264.493 311.376 265.115C311.376 265.304 311.512 265.358 311.674 265.385Z",
    fill: "#3D4561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.365 264.574C294.365 264.574 294.527 264.601 294.609 264.601C294.771 264.601 294.907 264.574 294.934 264.358C295.042 263.763 295.151 263.088 295.259 262.494C295.286 262.305 295.178 262.224 295.042 262.17C294.988 262.17 294.88 262.143 294.798 262.143C294.636 262.143 294.5 262.17 294.473 262.386C294.365 262.98 294.257 263.655 294.148 264.25C294.121 264.439 294.229 264.52 294.365 264.574Z",
    fill: "#5F6989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.036 266.465C304.036 266.465 304.198 266.465 304.279 266.465C304.442 266.465 304.55 266.384 304.55 266.168C304.55 265.547 304.55 264.872 304.55 264.25C304.55 264.061 304.442 263.98 304.279 263.953C304.225 263.953 304.117 263.953 304.036 263.953C303.873 263.953 303.765 264.034 303.765 264.25C303.765 264.872 303.765 265.547 303.765 266.168C303.765 266.357 303.873 266.438 304.036 266.465Z",
    fill: "#5F6989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.889 222.867C310.834 223.569 309.615 224.244 308.938 224.38C307.096 224.758 304.631 226.595 302.951 225.703C302.166 225.892 301.218 226.757 301.218 226.757C302.41 227.486 303.872 228.053 305.796 228.188C306.961 228.269 309.453 227.891 310.455 227.243C311.43 226.622 311.755 226.459 312.243 225.595C312.541 225.082 311.539 222.867 310.916 222.84L310.889 222.867Z",
    fill: "#2A8DCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.889 222.057C310.835 222.759 309.616 223.434 308.938 223.569C307.096 223.947 304.821 224.245 303.141 223.38C302.356 223.569 302.004 225.406 301.706 226.271C302.897 227 303.954 227.27 305.796 227.378C306.988 227.459 309.453 227.081 310.455 226.433C311.431 225.811 311.81 225.622 312.243 224.758C311.783 223.947 311.512 222.057 310.889 222.057Z",
    fill: "#4EA8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.366 234.13C293.037 233.428 291.98 236.156 291.005 239.641C290.03 243.153 288.052 251.148 287.158 253.552C285.858 254.633 284.964 255.254 282.472 256.551C279.411 258.117 274.941 259.927 271.528 261.656C271.013 261.926 271.718 263.412 271.745 263.763C271.772 264.222 273.208 265.87 273.424 265.762C277.244 264.276 284.26 262.115 287.104 260.71C291.33 258.604 291.791 257.982 293.145 254.363C294.499 250.77 296.179 244.125 297.317 240.802C298.102 237.615 297.777 234.86 295.366 234.13Z",
    fill: "#4EA8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44 261.656C269.199 261.575 270.093 262.143 270.824 262.305C271.095 262.359 271.772 262.116 271.799 262.116C272.72 262.251 273.316 265.006 273.208 265.114C272.558 265.762 271.989 265.627 271.474 266.086C270.472 266.978 267.384 268.463 266.083 268.463C265.081 268.463 264.079 268.679 264.268 268.193C264.539 267.572 266.625 266.897 266.95 266.032C267.059 265.735 268.142 264.331 267.952 263.412C267.763 262.602 265.596 262.764 265.65 262.197C265.731 261.386 267.627 261.737 268.413 261.683L268.44 261.656Z",
    fill: "#E8BEA4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prize",
    className: "prize"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.798 89.1592L276.435 98.7544H268.863L267.928 98.3081L261.217 102.579L253.286 97.393L255.422 96.8187L250.236 94.6895L259.798 89.1592Z",
    fill: "url(#paint181_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.798 89.1595L258.665 86.2007L259.798 86.8367L258.665 83.9333L263.336 86.6432L262.368 84.1269V70.5498L269.388 74.6146L276.435 92.7542V98.7547L259.798 89.1595Z",
    fill: "url(#paint182_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-460-outside-2_1515_6838",
    maskUnits: "userSpaceOnUse",
    x: 241.745,
    y: 69.3799,
    width: 30,
    height: 34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 241.745,
    y: 69.3799,
    width: 30,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.607 76.0404L253.896 72.3799L251.761 73.295L250.507 89.2217L246.576 91.4926L246.575 91.4925L244.745 92.5123L258.472 100.748L268.843 94.3426L268.049 91.4928L268.049 91.4925L268.049 91.4925L267.614 91.2421L263.603 88.9316L260.607 76.0404ZM258.112 85.7678L258.682 78.4746L258.112 85.7678L258.112 85.7678ZM258.777 77.2605L258.798 77.2464L251.761 73.295L258.777 77.2605Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.607 76.0404L253.896 72.3799L251.761 73.295L250.507 89.2217L246.576 91.4926L246.575 91.4925L244.745 92.5123L258.472 100.748L268.843 94.3426L268.049 91.4928L268.049 91.4925L268.049 91.4925L267.614 91.2421L263.603 88.9316L260.607 76.0404ZM258.112 85.7678L258.682 78.4746L258.112 85.7678L258.112 85.7678ZM258.777 77.2605L258.798 77.2464L251.761 73.295L258.777 77.2605Z",
    fill: "#8A5D11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prize-border",
    className: "border hide",
    d: "M253.896 72.3799L255.065 70.2375C254.408 69.8792 253.623 69.8421 252.935 70.1369L253.896 72.3799ZM260.607 76.0404L262.984 75.4879C262.827 74.8098 262.387 74.2314 261.776 73.898L260.607 76.0404ZM251.761 73.295L250.8 71.052C249.966 71.4093 249.399 72.1993 249.328 73.1034L251.761 73.295ZM250.507 89.2217L251.728 91.3348C252.423 90.9329 252.877 90.2143 252.94 89.4133L250.507 89.2217ZM246.576 91.4926L245.355 93.6057C246.11 94.042 247.041 94.042 247.796 93.6058L246.576 91.4926ZM246.575 91.4925L247.796 89.3794C247.052 88.9499 246.138 88.9428 245.388 89.3608L246.575 91.4925ZM244.745 92.5123L243.557 90.3806C242.796 90.8046 242.319 91.6022 242.305 92.4732C242.291 93.3443 242.743 94.1567 243.49 94.6049L244.745 92.5123ZM258.472 100.748L257.216 102.841C257.999 103.31 258.978 103.304 259.754 102.825L258.472 100.748ZM268.843 94.3426L270.126 96.4188C271.05 95.8477 271.486 94.7341 271.194 93.6872L268.843 94.3426ZM268.049 91.4928L265.652 91.9501C265.664 92.0167 265.68 92.0828 265.698 92.1481L268.049 91.4928ZM268.049 91.4925L270.446 91.0352C270.311 90.3284 269.871 89.7172 269.244 89.3648C268.616 89.0125 267.866 88.9549 267.192 89.2076L268.049 91.4925ZM268.049 91.4925L266.831 93.6074C267.463 93.9709 268.223 94.0333 268.906 93.7775L268.049 91.4925ZM267.614 91.2421L266.395 93.3566L266.396 93.357L267.614 91.2421ZM263.603 88.9316L261.226 89.484C261.38 90.1428 261.799 90.7084 262.385 91.046L263.603 88.9316ZM258.682 78.4746L261.115 78.6646C261.22 77.321 260.216 76.1466 258.872 76.0417C257.529 75.9367 256.354 76.9408 256.249 78.2845L258.682 78.4746ZM258.112 85.7678L256.902 87.8866C257.627 88.3014 258.515 88.3157 259.254 87.9246C259.993 87.5335 260.48 86.7913 260.545 85.9579L258.112 85.7678ZM258.112 85.7678L255.679 85.5777C255.606 86.5189 256.082 87.4181 256.902 87.8866L258.112 85.7678ZM258.798 77.2464L260.152 79.2765C260.858 78.8055 261.269 78.0012 261.237 77.1529C261.204 76.3046 260.733 75.5342 259.993 75.1185L258.798 77.2464ZM258.777 77.2605L257.576 79.385C258.377 79.8378 259.365 79.8014 260.131 79.2907L258.777 77.2605ZM252.728 74.5222L259.439 78.1827L261.776 73.898L255.065 70.2375L252.728 74.5222ZM252.722 75.538L254.858 74.6229L252.935 70.1369L250.8 71.052L252.722 75.538ZM249.328 73.1034L248.074 89.0302L252.94 89.4133L254.194 73.4866L249.328 73.1034ZM249.286 87.1086L245.355 89.3795L247.796 93.6058L251.728 91.3348L249.286 87.1086ZM247.796 89.3796L247.796 89.3794L245.355 93.6056L245.355 93.6057L247.796 89.3796ZM245.388 89.3608L243.557 90.3806L245.933 94.644L247.763 93.6242L245.388 89.3608ZM243.49 94.6049L257.216 102.841L259.727 98.6558L246.001 90.4198L243.49 94.6049ZM259.754 102.825L270.126 96.4188L267.561 92.2663L257.19 98.6722L259.754 102.825ZM271.194 93.6872L270.399 90.8375L265.698 92.1481L266.493 94.9979L271.194 93.6872ZM270.446 91.0355L270.446 91.0352L265.652 91.9498L265.652 91.9501L270.446 91.0355ZM267.192 89.2076L267.192 89.2076L268.906 93.7775L268.906 93.7774L267.192 89.2076ZM269.266 89.3776L268.831 89.1272L266.396 93.357L266.831 93.6074L269.266 89.3776ZM268.832 89.1277L264.822 86.8171L262.385 91.046L266.395 93.3566L268.832 89.1277ZM265.98 88.3791L262.984 75.4879L258.23 76.5928L261.226 89.484L265.98 88.3791ZM256.249 78.2845L255.679 85.5777L260.545 85.9579L261.115 78.6646L256.249 78.2845ZM260.545 85.9578L261.115 78.6646L256.249 78.2845L255.679 85.5777L260.545 85.9578ZM259.323 83.649L259.323 83.649L256.902 87.8866L256.902 87.8866L259.323 83.649ZM257.444 75.2162L257.423 75.2303L260.131 79.2907L260.152 79.2765L257.444 75.2162ZM259.993 75.1185L252.956 71.1672L250.566 75.4228L257.603 79.3742L259.993 75.1185ZM259.978 75.1361L252.962 71.1706L250.56 75.4194L257.576 79.385L259.978 75.1361Z",
    fill: "white",
    mask: "url(#path-460-outside-2_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.049 91.4928L257.298 97.6869L246.575 91.4928L257.298 85.2988L268.049 91.4928Z",
    fill: "#FFCC77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.049 91.4929L261.996 94.9771L257.713 92.5437H256.055L257.713 90.4422L259.122 89.6679L261.996 88.0088L268.049 91.4929Z",
    fill: "#AD7A24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.298 97.6862L258.472 100.748L244.745 92.512L246.575 91.4922L257.298 97.6862Z",
    fill: "#FFD288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.049 91.4922L257.298 97.6862L258.472 100.748L268.843 94.3422L268.049 91.4922Z",
    fill: "#8A5D11"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.607 76.0404L258.823 77.2604L251.761 73.295L253.897 72.3799L260.607 76.0404Z",
    fill: "#FFCC77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.761 73.2949L258.777 77.2604L257.298 96.1887L250.278 92.1239L251.761 73.2949Z",
    fill: "#FFC25E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.607 76.04L258.777 77.2602L257.298 96.1885L264.346 92.1236L260.607 76.04Z",
    fill: "#8A5D11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "puzzle",
    className: "puzzle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.9 295.128H177.062L189.958 289.877L180.043 281.484L173.9 295.128Z",
    fill: "url(#paint183_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.497 291.449C194.409 291.486 194.279 291.469 194.208 291.412L189.911 288.051L190.882 287.761C190.882 287.761 192.796 288.084 192.773 288.001C192.766 287.978 192.753 287.956 192.737 287.936C192.702 287.893 192.624 287.806 192.407 287.791C192.174 287.775 191.941 287.704 191.804 287.564C191.643 287.4 191.065 286.622 191.813 286.116C192.1 285.964 192.809 286.677 193.059 286.875C193.199 286.986 193.07 287.42 193.029 287.536C192.985 287.658 193.103 287.728 193.165 287.761C193.193 287.776 193.225 287.79 193.261 287.801C193.392 287.84 193.584 287.839 193.877 287.704C194.208 287.552 195.351 286.646 195.395 286.622C196.32 286.112 196.642 286.875 196.642 286.875C195.314 286.724 195.504 288.166 196.34 288.018C196.34 287.801 196.506 287.994 196.506 287.905L196.507 287.906C196.517 287.914 196.528 287.924 196.54 287.933C196.547 287.94 196.555 287.947 196.563 287.954C196.572 287.961 196.579 287.969 196.586 287.976C196.6 287.99 196.613 288.004 196.623 288.018C196.629 288.025 196.633 288.031 196.637 288.038C196.64 288.042 196.642 288.047 196.645 288.051C196.647 288.057 196.65 288.062 196.652 288.067C196.655 288.074 196.656 288.081 196.656 288.087C196.656 288.092 196.656 288.097 196.655 288.102C196.654 288.107 196.652 288.112 196.649 288.116C196.643 288.124 196.635 288.131 196.622 288.14C196.58 288.17 196.542 288.181 196.458 288.166C196.173 288.113 195.902 288.13 195.694 288.215C195.335 288.363 195.265 288.662 195.523 288.899C195.527 288.903 195.532 288.908 195.538 288.913C195.546 288.92 195.555 288.927 195.564 288.934L195.581 288.948C195.878 289.17 196.397 289.239 196.764 289.106C196.993 289.024 197.125 288.874 197.126 288.695C197.126 288.645 197.157 288.629 197.223 288.614C197.241 288.61 197.256 288.608 197.268 288.608C197.336 288.606 197.415 288.644 197.482 288.686C197.486 288.689 197.492 288.693 197.497 288.696C197.502 288.699 197.507 288.703 197.512 288.706C197.521 288.713 197.529 288.719 197.538 288.725C197.552 288.735 197.563 288.744 197.574 288.752C197.591 288.765 197.607 288.779 197.624 288.793L197.63 288.799C197.751 288.904 198.636 288.393 198.636 288.393L199.633 289.151C199.633 289.151 195.167 291.175 194.497 291.449Z",
    fill: "#A98957"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-471-outside-3_1515_6838",
    maskUnits: "userSpaceOnUse",
    x: 161.986,
    y: 276.274,
    width: 27,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 161.986,
    y: 276.274,
    width: 27,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.901 295.128L163.986 286.713V283.503V283.502L163.987 283.503L176.882 278.274L186.796 286.69L186.797 286.69V286.69L186.797 286.69L186.797 286.69V289.877L173.901 295.128L173.901 295.128L173.901 295.128Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.901 295.128L163.986 286.713V283.503V283.502L163.987 283.503L176.882 278.274L186.796 286.69L186.797 286.69V286.69L186.797 286.69L186.797 286.69V289.877L173.901 295.128L173.901 295.128L173.901 295.128Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puzzle-border-1",
    className: "border hide",
    d: "M163.986 286.713H162.156C162.156 287.25 162.392 287.76 162.802 288.108L163.986 286.713ZM173.901 295.128L175.552 294.338C175.44 294.106 175.281 293.899 175.085 293.733L173.901 295.128ZM163.986 283.502L165.171 282.108C164.628 281.646 163.865 281.542 163.218 281.841C162.571 282.141 162.156 282.789 162.156 283.502H163.986ZM163.987 283.503L162.801 284.897C163.321 285.339 164.042 285.455 164.674 285.199L163.987 283.503ZM176.882 278.274L178.066 276.879C177.547 276.438 176.826 276.322 176.194 276.578L176.882 278.274ZM186.796 286.69L185.612 288.085C186.027 288.438 186.578 288.587 187.114 288.492L186.796 286.69ZM186.797 286.69H188.627C188.627 286.149 188.388 285.636 187.973 285.288C187.559 284.94 187.012 284.793 186.479 284.887L186.797 286.69ZM186.797 286.69H184.966C184.966 287.23 185.205 287.743 185.619 288.091L186.797 286.69ZM186.797 286.69L187.49 288.384C188.083 288.141 188.506 287.606 188.605 286.973C188.704 286.34 188.465 285.702 187.975 285.289L186.797 286.69ZM186.797 286.69L186.104 284.996C185.416 285.277 184.966 285.947 184.966 286.69H186.797ZM186.797 289.877L187.487 291.572C188.176 291.292 188.627 290.621 188.627 289.877H186.797ZM173.901 295.128L173.211 293.433C172.978 293.528 172.768 293.669 172.593 293.848L173.901 295.128ZM173.901 295.128L172.25 295.919C172.508 296.458 173.013 296.837 173.602 296.934C174.192 297.032 174.791 296.835 175.209 296.408L173.901 295.128ZM162.802 288.108L172.716 296.524L175.085 293.733L165.171 285.317L162.802 288.108ZM162.156 283.503V286.713H165.817V283.503H162.156ZM162.156 283.502V283.503H165.817V283.502H162.156ZM165.172 282.108L165.171 282.108L162.801 284.897L162.801 284.897L165.172 282.108ZM164.674 285.199L177.57 279.971L176.194 276.578L163.299 281.806L164.674 285.199ZM175.698 279.67L185.612 288.085L187.981 285.294L178.066 276.879L175.698 279.67ZM187.114 288.492L187.114 288.492L186.479 284.887L186.479 284.887L187.114 288.492ZM184.966 286.69V286.69H188.627V286.69H184.966ZM185.619 288.091L185.619 288.091L187.975 285.289L187.975 285.289L185.619 288.091ZM186.104 284.996L186.104 284.996L187.49 288.384L187.49 288.384L186.104 284.996ZM184.966 286.69V289.877H188.627V286.69H184.966ZM186.106 288.182L173.211 293.433L174.591 296.823L187.487 291.572L186.106 288.182ZM172.593 293.848L172.593 293.848L175.209 296.408L175.209 296.408L172.593 293.848ZM175.552 294.338L175.552 294.338L172.25 295.919L172.25 295.919L175.552 294.338Z",
    fill: "white",
    mask: "url(#path-471-outside-3_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.901 295.128L171.168 289.418L186.796 286.689V289.877L173.901 295.128Z",
    fill: "url(#paint184_linear_1515_6838)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.986 283.503L173.901 291.918L186.797 286.69L176.882 278.274L163.986 283.503Z",
    fill: "#469D34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.901 295.128V291.918L163.986 283.502V286.712L173.901 295.128Z",
    fill: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1515_6838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.795 287.924L194.59 289.678C194.501 289.714 194.372 289.698 194.3 289.641L190.975 287.005C190.975 287.005 192.141 286.665 192.508 286.532C192.826 286.416 192.888 286.313 192.865 286.23C192.859 286.207 192.846 286.185 192.83 286.165C192.795 286.121 192.717 286.035 192.499 286.02C192.267 286.004 192.033 285.933 191.896 285.793C191.735 285.629 191.773 285.427 191.988 285.313C192.275 285.161 192.743 285.209 192.993 285.407C193.133 285.518 193.163 285.649 193.121 285.765C193.077 285.887 193.195 285.957 193.258 285.99C193.286 286.005 193.317 286.019 193.354 286.029C193.485 286.068 193.676 286.068 193.97 285.932C194.3 285.78 195.199 285.28 195.243 285.255C195.243 285.255 195.244 285.254 195.244 285.254C195.244 285.254 196.236 285.87 196.539 286.089L196.546 286.094C196.564 286.108 196.582 286.121 196.598 286.134L196.599 286.135C196.61 286.143 196.621 286.152 196.632 286.162C196.64 286.169 196.647 286.175 196.655 286.182C196.664 286.19 196.671 286.197 196.679 286.205C196.692 286.219 196.705 286.233 196.716 286.247C196.721 286.254 196.726 286.26 196.73 286.266C196.732 286.271 196.735 286.275 196.737 286.28C196.74 286.285 196.742 286.29 196.744 286.296C196.747 286.303 196.748 286.309 196.748 286.316C196.749 286.321 196.748 286.325 196.747 286.33C196.746 286.335 196.744 286.34 196.741 286.345C196.736 286.353 196.727 286.36 196.714 286.369C196.672 286.398 196.635 286.41 196.55 286.394C196.266 286.341 195.994 286.359 195.786 286.444C195.427 286.591 195.357 286.891 195.615 287.127C195.62 287.132 195.625 287.137 195.63 287.141C195.638 287.149 195.647 287.156 195.656 287.163L195.673 287.177C195.97 287.398 196.489 287.468 196.857 287.335C197.086 287.253 197.217 287.103 197.218 286.923C197.219 286.874 197.25 286.858 197.315 286.843C197.333 286.839 197.348 286.837 197.361 286.837C197.428 286.834 197.508 286.873 197.574 286.915C197.579 286.918 197.584 286.921 197.589 286.925C197.594 286.928 197.599 286.931 197.604 286.935C197.613 286.941 197.622 286.947 197.63 286.953C197.644 286.963 197.656 286.973 197.667 286.981C197.683 286.994 197.699 287.008 197.716 287.022L197.723 287.027C197.99 287.26 198.795 287.924 198.795 287.924Z",
    fill: "#469D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puzzle-border-2",
    className: "border hide",
    d: "M195.244 285.254C194.527 284.685 194.527 284.686 194.526 284.686L194.526 284.686L194.524 284.687L194.52 284.689L194.513 284.692L194.499 284.698C194.489 284.702 194.48 284.706 194.471 284.71C194.453 284.719 194.437 284.728 194.421 284.737C194.416 284.74 194.411 284.742 194.406 284.745C194.402 284.747 194.398 284.749 194.394 284.752C194.307 284.8 194.077 284.928 193.836 285.058C193.129 284.5 191.893 284.41 191.185 284.784L191.184 284.785C190.636 285.076 190.51 285.602 190.962 286.061C191.004 286.104 191.048 286.144 191.095 286.182C191.06 286.192 191.025 286.203 190.991 286.213C190.825 286.263 190.67 286.309 190.557 286.342L190.422 286.382L190.385 286.393L190.376 286.395L190.373 286.396L190.373 286.396L190.373 286.396L190.373 286.396C190.373 286.396 190.373 286.396 190.373 286.396C190.105 286.474 189.924 286.624 189.877 286.807C189.831 286.99 189.922 287.188 190.128 287.352L193.453 289.988C193.951 290.383 194.787 290.459 195.307 290.246L195.307 290.246L195.313 290.244L199.518 288.49C199.973 288.3 200.035 287.901 199.657 287.589L199.657 287.589L199.657 287.589L199.656 287.589L199.655 287.587L199.648 287.582L199.622 287.561L199.528 287.483C199.449 287.417 199.341 287.328 199.224 287.231C198.987 287.034 198.729 286.818 198.606 286.71C198.597 286.703 198.589 286.696 198.581 286.689C198.559 286.671 198.537 286.653 198.513 286.634L198.512 286.632C198.501 286.624 198.471 286.6 198.432 286.573L198.411 286.557C198.401 286.55 198.391 286.543 198.381 286.537L198.367 286.527L198.362 286.524L198.362 286.524L198.339 286.509C198.332 286.504 198.325 286.499 198.318 286.495C198.251 286.453 198.133 286.384 197.977 286.321C197.939 286.306 197.891 286.288 197.833 286.27C197.83 286.26 197.826 286.249 197.822 286.239C197.815 286.22 197.806 286.2 197.794 286.177C197.784 286.158 197.775 286.143 197.775 286.142L197.765 286.126C197.745 286.092 197.723 286.064 197.712 286.05C197.674 286 197.635 285.959 197.615 285.938C197.609 285.932 197.603 285.926 197.597 285.92C197.6 285.923 197.602 285.925 197.601 285.924L197.6 285.923L197.598 285.921L197.592 285.915C197.582 285.905 197.562 285.886 197.536 285.863L197.534 285.862L197.52 285.85L197.506 285.837L197.504 285.835C197.495 285.827 197.471 285.807 197.446 285.788L197.445 285.787C197.423 285.769 197.399 285.751 197.373 285.732C197.365 285.725 197.356 285.719 197.347 285.712C197.161 285.578 196.803 285.348 196.526 285.172C196.38 285.08 196.244 284.995 196.145 284.933L196.026 284.859L195.993 284.838L195.985 284.833L195.982 284.831L195.982 284.831L195.981 284.831L195.981 284.831L195.244 285.254ZM195.244 285.254L195.981 284.831C195.569 284.575 194.949 284.513 194.527 284.685L195.244 285.254ZM197.827 286.982L197.832 286.983L197.844 286.984L198.328 287.03C198.327 287.087 198.307 287.215 198.15 287.333C198.138 287.342 198.126 287.35 198.113 287.358C198.144 287.384 198.174 287.409 198.205 287.435C198.285 287.309 198.327 287.172 198.328 287.029L197.846 286.983L197.834 286.982L197.829 286.981L197.827 286.982ZM197.827 286.982L197.816 286.981L197.716 287.022L197.827 286.982ZM196.376 287.028C196.376 287.028 196.376 287.028 196.376 287.028L196.376 287.028ZM191.988 285.313L191.988 285.313L191.988 285.313Z",
    stroke: "white",
    strokeWidth: 1.83024,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1515_6838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.795 287.924L194.59 289.678C194.501 289.714 194.372 289.698 194.3 289.641L190.975 287.005C190.975 287.005 192.141 286.665 192.508 286.532C192.826 286.416 192.888 286.313 192.865 286.23C192.859 286.207 192.846 286.185 192.83 286.165C192.795 286.121 192.717 286.035 192.499 286.02C192.267 286.004 192.033 285.933 191.896 285.793C191.735 285.629 191.773 285.427 191.988 285.313C192.275 285.161 192.743 285.209 192.993 285.407C193.133 285.518 193.163 285.649 193.121 285.765C193.077 285.887 193.195 285.957 193.258 285.99C193.286 286.005 193.317 286.019 193.354 286.029C193.485 286.068 193.676 286.068 193.97 285.932C194.3 285.78 195.199 285.28 195.243 285.255C195.243 285.255 195.244 285.254 195.244 285.254C195.244 285.254 196.236 285.87 196.539 286.089L196.546 286.094C196.564 286.108 196.582 286.121 196.598 286.134L196.599 286.135C196.61 286.143 196.621 286.152 196.632 286.162C196.64 286.169 196.647 286.175 196.655 286.182C196.664 286.19 196.671 286.197 196.679 286.205C196.692 286.219 196.705 286.233 196.716 286.247C196.721 286.254 196.726 286.26 196.73 286.266C196.732 286.271 196.735 286.275 196.737 286.28C196.74 286.285 196.742 286.29 196.744 286.296C196.747 286.303 196.748 286.309 196.748 286.316C196.749 286.321 196.748 286.325 196.747 286.33C196.746 286.335 196.744 286.34 196.741 286.345C196.736 286.353 196.727 286.36 196.714 286.369C196.672 286.398 196.635 286.41 196.55 286.394C196.266 286.341 195.994 286.359 195.786 286.444C195.427 286.591 195.357 286.891 195.615 287.127C195.62 287.132 195.625 287.137 195.63 287.141C195.638 287.149 195.647 287.156 195.656 287.163L195.673 287.177C195.97 287.398 196.489 287.468 196.857 287.335C197.086 287.253 197.217 287.103 197.218 286.923C197.219 286.874 197.25 286.858 197.315 286.843C197.333 286.839 197.348 286.837 197.361 286.837C197.428 286.834 197.508 286.873 197.574 286.915C197.579 286.918 197.584 286.921 197.589 286.925C197.594 286.928 197.599 286.931 197.604 286.935C197.613 286.941 197.622 286.947 197.63 286.953C197.644 286.963 197.656 286.973 197.667 286.981C197.683 286.994 197.699 287.008 197.716 287.022L197.723 287.027C197.99 287.26 198.795 287.924 198.795 287.924Z",
    fill: "#469D34"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1515_6838",
    x: 188.756,
    y: 283.893,
    width: 12.2583,
    height: 7.74582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.610079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1515_6838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1515_6838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1515_6838",
    x: 190.975,
    y: 285.224,
    width: 7.81982,
    height: 5.08371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.610079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1515_6838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1515_6838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1515_6838",
    x1: 94.1014,
    y1: 224.621,
    x2: 129.008,
    y2: 287.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1515_6838",
    x1: 184.334,
    y1: 100.906,
    x2: 153.906,
    y2: 100.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1515_6838",
    x1: 364.909,
    y1: 284.791,
    x2: 467.359,
    y2: 182.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC1B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED3C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1515_6838",
    x1: 420.928,
    y1: 203.55,
    x2: 304.108,
    y2: 265.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1515_6838",
    x1: 250.854,
    y1: 274.338,
    x2: 196.697,
    y2: 180.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1515_6838",
    x1: 226.922,
    y1: 290.874,
    x2: 170.413,
    y2: 193.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1515_6838",
    x1: 164.823,
    y1: 315.18,
    x2: 141.346,
    y2: 291.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B664B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1515_6838",
    x1: 361.289,
    y1: 241.627,
    x2: 334.066,
    y2: 246.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1515_6838",
    x1: 189.695,
    y1: 161.021,
    x2: 212.357,
    y2: 161.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A77C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1515_6838",
    x1: 255.912,
    y1: 219.339,
    x2: 234.024,
    y2: 219.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1515_6838",
    x1: 315.274,
    y1: 205.126,
    x2: 251.602,
    y2: 315.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1515_6838",
    x1: 292.06,
    y1: 245.58,
    x2: 284.398,
    y2: 258.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1515_6838",
    x1: 352.335,
    y1: 284.126,
    x2: 345.643,
    y2: 276.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1515_6838",
    x1: 33.6056,
    y1: 314.461,
    x2: 55.4501,
    y2: 293.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1515_6838",
    x1: 59.5563,
    y1: 111.663,
    x2: 59.6946,
    y2: 107.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1515_6838",
    x1: 21.2246,
    y1: 257.415,
    x2: 5.4979,
    y2: 262.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1515_6838",
    x1: 118.311,
    y1: 83.0155,
    x2: 114.382,
    y2: 68.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1515_6838",
    x1: 75.0047,
    y1: 226.335,
    x2: 59.278,
    y2: 231.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1515_6838",
    x1: 128.758,
    y1: 195.282,
    x2: 113.031,
    y2: 200.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1515_6838",
    x1: -77.1882,
    y1: 164.422,
    x2: 287.583,
    y2: 164.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1515_6838",
    x1: -77.1882,
    y1: 133.342,
    x2: 287.583,
    y2: 133.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1515_6838",
    x1: 381.989,
    y1: 296.349,
    x2: 381.408,
    y2: 313.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2B1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4A290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1515_6838",
    x1: 235.074,
    y1: 233.331,
    x2: 243.344,
    y2: 219.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1515_6838",
    x1: 341.032,
    y1: 296.819,
    x2: 351.293,
    y2: 279.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D815A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1515_6838",
    x1: 205.228,
    y1: 248.207,
    x2: 215.376,
    y2: 238.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1515_6838",
    x1: 119.168,
    y1: 274.67,
    x2: 102.24,
    y2: 244.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C7441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1515_6838",
    x1: 223.191,
    y1: 407.178,
    x2: 207.758,
    y2: 385.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1515_6838",
    x1: 212.827,
    y1: 386.052,
    x2: 179.534,
    y2: 352.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B664B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1515_6838",
    x1: 154.432,
    y1: 303.898,
    x2: 147.102,
    y2: 291.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#988E74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1515_6838",
    x1: 131.3,
    y1: 293.307,
    x2: 130.94,
    y2: 291.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1515_6838",
    x1: 127.293,
    y1: 297.068,
    x2: 140.503,
    y2: 297.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1515_6838",
    x1: 145.891,
    y1: 265.656,
    x2: 162.322,
    y2: 297.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89A7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1515_6838",
    x1: 155.885,
    y1: 280.662,
    x2: 151.93,
    y2: 273.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1515_6838",
    x1: 177.729,
    y1: 264.992,
    x2: 175.297,
    y2: 264.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1515_6838",
    x1: 82.4945,
    y1: 265.241,
    x2: 84.9267,
    y2: 264.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1515_6838",
    x1: 83.4338,
    y1: 320.96,
    x2: 83.0741,
    y2: 319.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1515_6838",
    x1: 79.4265,
    y1: 324.72,
    x2: 92.6367,
    y2: 324.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1515_6838",
    x1: 108.772,
    y1: 309.648,
    x2: 104.512,
    y2: 301.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1515_6838",
    x1: 131.19,
    y1: 293.004,
    x2: 128.785,
    y2: 292.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1515_6838",
    x1: 34.628,
    y1: 292.892,
    x2: 37.0602,
    y2: 292.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1515_6838",
    x1: 248.228,
    y1: 317.697,
    x2: 250.331,
    y2: 347.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1515_6838",
    x1: 155.039,
    y1: 298.147,
    x2: 181.991,
    y2: 311.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1515_6838",
    x1: 131.3,
    y1: 348.611,
    x2: 130.94,
    y2: 347.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1515_6838",
    x1: 127.293,
    y1: 352.372,
    x2: 140.503,
    y2: 352.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1515_6838",
    x1: 156.636,
    y1: 337.33,
    x2: 152.376,
    y2: 329.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1515_6838",
    x1: 179.056,
    y1: 320.655,
    x2: 176.651,
    y2: 319.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1515_6838",
    x1: 82.5767,
    y1: 320.766,
    x2: 84.9812,
    y2: 320.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1515_6838",
    x1: 179.167,
    y1: 376.263,
    x2: 178.807,
    y2: 374.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1515_6838",
    x1: 175.159,
    y1: 380.024,
    x2: 188.37,
    y2: 380.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1515_6838",
    x1: 204.497,
    y1: 364.971,
    x2: 200.237,
    y2: 357.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1515_6838",
    x1: 226.922,
    y1: 348.307,
    x2: 224.517,
    y2: 347.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1515_6838",
    x1: 130.443,
    y1: 348.417,
    x2: 132.848,
    y2: 347.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1515_6838",
    x1: 95.0692,
    y1: 267.094,
    x2: 92.3037,
    y2: 270.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A59677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A19373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1515_6838",
    x1: 115.382,
    y1: 282.246,
    x2: 114.552,
    y2: 283.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A59677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A19373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1515_6838",
    x1: 96.9758,
    y1: 269.665,
    x2: 94.4587,
    y2: 265.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ACA083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AA9C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A8D72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1515_6838",
    x1: 91.0061,
    y1: 264.771,
    x2: 90.8125,
    y2: 266.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1515_6838",
    x1: 80.919,
    y1: 197.77,
    x2: 126.738,
    y2: 243.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFC3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1515_6838",
    x1: 90.8956,
    y1: 251.692,
    x2: 90.5359,
    y2: 241.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1515_6838",
    x1: 94.0185,
    y1: 257.498,
    x2: 89.652,
    y2: 257.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1515_6838",
    x1: 106.317,
    y1: 228.907,
    x2: 124.24,
    y2: 261.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89A7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1515_6838",
    x1: 115.543,
    y1: 235.256,
    x2: 111.56,
    y2: 228.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C6AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1515_6838",
    x1: 137.795,
    y1: 219.477,
    x2: 138.348,
    y2: 220.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1515_6838",
    x1: 43.1399,
    y1: 292.423,
    x2: 42.9463,
    y2: 294.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1515_6838",
    x1: 38.5251,
    y1: 240.216,
    x2: 84.2888,
    y2: 285.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFC3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1515_6838",
    x1: 46.0141,
    y1: 286.478,
    x2: 45.6268,
    y2: 285.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1515_6838",
    x1: 39.0774,
    y1: 285.151,
    x2: 52.2875,
    y2: 285.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1515_6838",
    x1: 58.451,
    y1: 256.558,
    x2: 76.3748,
    y2: 288.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89A7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1515_6838",
    x1: 67.7013,
    y1: 262.911,
    x2: 63.7182,
    y2: 255.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBAF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C6AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1515_6838",
    x1: 89.9284,
    y1: 247.129,
    x2: 90.4816,
    y2: 248.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1515_6838",
    x1: 85.4791,
    y1: 296.349,
    x2: 71.0155,
    y2: 314.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1515_6838",
    x1: 83.1851,
    y1: 319.355,
    x2: 82.9914,
    y2: 321.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1515_6838",
    x1: 87.745,
    y1: 314.987,
    x2: 84.5912,
    y2: 303.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1515_6838",
    x1: 82.7152,
    y1: 308.46,
    x2: 85.0643,
    y2: 308.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1515_6838",
    x1: 85.949,
    y1: 304.479,
    x2: 100.775,
    y2: 330.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1515_6838",
    x1: 88.4868,
    y1: 298.656,
    x2: 84.3654,
    y2: 291.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1515_6838",
    x1: 93.8535,
    y1: 299.861,
    x2: 94.6832,
    y2: 301.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1515_6838",
    x1: 131.383,
    y1: 343.385,
    x2: 131.189,
    y2: 345.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1515_6838",
    x1: 134.229,
    y1: 337.44,
    x2: 133.842,
    y2: 336.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1515_6838",
    x1: 129.31,
    y1: 336.113,
    x2: 134.174,
    y2: 336.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1515_6838",
    x1: 130.028,
    y1: 325.577,
    x2: 144.937,
    y2: 351.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1515_6838",
    x1: 136.364,
    y1: 326.319,
    x2: 132.243,
    y2: 318.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1515_6838",
    x1: 137.988,
    y1: 321.014,
    x2: 138.79,
    y2: 322.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1515_6838",
    x1: 179.249,
    y1: 371.037,
    x2: 179.055,
    y2: 373.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1515_6838",
    x1: 182.096,
    y1: 365.092,
    x2: 181.708,
    y2: 363.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1515_6838",
    x1: 177.176,
    y1: 363.765,
    x2: 182.04,
    y2: 363.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1515_6838",
    x1: 176.651,
    y1: 351.045,
    x2: 181.436,
    y2: 359.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1515_6838",
    x1: 184.242,
    y1: 353.946,
    x2: 180.093,
    y2: 346.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1515_6838",
    x1: 185.854,
    y1: 348.667,
    x2: 186.656,
    y2: 350.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1515_6838",
    x1: 174.053,
    y1: 373.305,
    x2: 199.527,
    y2: 417.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1515_6838",
    x1: 187.319,
    y1: 397.72,
    x2: 187.153,
    y2: 399.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1515_6838",
    x1: 192.542,
    y1: 391.166,
    x2: 192.099,
    y2: 389.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1515_6838",
    x1: 182.98,
    y1: 386.41,
    x2: 196.19,
    y2: 386.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1515_6838",
    x1: 248.202,
    y1: 428.552,
    x2: 208.567,
    y2: 365.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A588"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1515_6838",
    x1: 213.801,
    y1: 357.148,
    x2: 209.348,
    y2: 349.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1515_6838",
    x1: 242.786,
    y1: 342.859,
    x2: 251.383,
    y2: 347.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1515_6838",
    x1: 186.103,
    y1: 355.635,
    x2: 192.022,
    y2: 365.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1515_6838",
    x1: 307.95,
    y1: 224.759,
    x2: 301.979,
    y2: 229.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1515_6838",
    x1: 219.516,
    y1: 310.01,
    x2: 217.192,
    y2: 305.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B374E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1515_6838",
    x1: 217.637,
    y1: 297.429,
    x2: 216.088,
    y2: 299.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B374E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1515_6838",
    x1: 207.439,
    y1: 298.7,
    x2: 208.186,
    y2: 300.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B374E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1515_6838",
    x1: 212.717,
    y1: 305.447,
    x2: 212.579,
    y2: 297.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1515_6838",
    x1: 211.032,
    y1: 300.94,
    x2: 211.336,
    y2: 297.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1515_6838",
    x1: 214.21,
    y1: 293.474,
    x2: 224.938,
    y2: 303.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1515_6838",
    x1: 221.423,
    y1: 298.342,
    x2: 220.122,
    y2: 295.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1515_6838",
    x1: 213.407,
    y1: 298.59,
    x2: 216.45,
    y2: 292.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1515_6838",
    x1: 219.847,
    y1: 293.335,
    x2: 226.623,
    y2: 303.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1515_6838",
    x1: 220.068,
    y1: 292.783,
    x2: 221.672,
    y2: 295.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1515_6838",
    x1: 223.385,
    y1: 291.954,
    x2: 226.897,
    y2: 298.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79714A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1515_6838",
    x1: 362.394,
    y1: 160.385,
    x2: 370.52,
    y2: 160.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B68850"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1515_6838",
    x1: 351.534,
    y1: 164.367,
    x2: 351.534,
    y2: 160.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A24B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1515_6838",
    x1: 342.248,
    y1: 149.711,
    x2: 345.067,
    y2: 149.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A24B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1515_6838",
    x1: 366.43,
    y1: 241.268,
    x2: 374.527,
    y2: 241.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B68850"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1515_6838",
    x1: 357.116,
    y1: 248.015,
    x2: 357.504,
    y2: 242.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A824C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1515_6838",
    x1: 347.361,
    y1: 232.115,
    x2: 352.335,
    y2: 232.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A824C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1515_6838",
    x1: 366.43,
    y1: 200.924,
    x2: 374.527,
    y2: 200.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B68850"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1515_6838",
    x1: 358.083,
    y1: 202.942,
    x2: 357.945,
    y2: 198.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A98A68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1515_6838",
    x1: 351.506,
    y1: 193.264,
    x2: 354.325,
    y2: 193.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A98A68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1515_6838",
    x1: 333.321,
    y1: 295.355,
    x2: 330.97,
    y2: 291.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1515_6838",
    x1: 318.785,
    y1: 252.744,
    x2: 331.646,
    y2: 274.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#927745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C804C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1515_6838",
    x1: 272.742,
    y1: 245.249,
    x2: 268.455,
    y2: 252.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1515_6838",
    x1: 275.285,
    y1: 246.632,
    x2: 268.977,
    y2: 268.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1515_6838",
    x1: 264.534,
    y1: 244.697,
    x2: 249.407,
    y2: 262.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1515_6838",
    x1: 265.778,
    y1: 296.074,
    x2: 229.648,
    y2: 161.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B703B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1515_6838",
    x1: 252.596,
    y1: 255.647,
    x2: 252.181,
    y2: 254.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1515_6838",
    x1: 248.202,
    y1: 247.49,
    x2: 252.762,
    y2: 247.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1515_6838",
    x1: 283.023,
    y1: 260.486,
    x2: 265.296,
    y2: 281.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1515_6838",
    x1: 305.436,
    y1: 318.998,
    x2: 269.333,
    y2: 184.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B703B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1515_6838",
    x1: 291.038,
    y1: 276.026,
    x2: 290.623,
    y2: 276.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1515_6838",
    x1: 286.339,
    y1: 273.151,
    x2: 292.476,
    y2: 269.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1515_6838",
    x1: 249.97,
    y1: 249.979,
    x2: 236.809,
    y2: 261.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1515_6838",
    x1: 226.12,
    y1: 322.454,
    x2: 225.097,
    y2: 320.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1515_6838",
    x1: 237.175,
    y1: 69.1347,
    x2: 222.251,
    y2: 68.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1515_6838",
    x1: 207.935,
    y1: 108.429,
    x2: 199.137,
    y2: 70.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B814E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1515_6838",
    x1: 192.459,
    y1: 112.245,
    x2: 232.947,
    y2: 109.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1515_6838",
    x1: 170.267,
    y1: 98.9992,
    x2: 187.346,
    y2: 98.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1515_6838",
    x1: 210.119,
    y1: 104.363,
    x2: 202.706,
    y2: 91.5088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B703B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1515_6838",
    x1: 193.703,
    y1: 83.1548,
    x2: 208.197,
    y2: 58.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1515_6838",
    x1: 197.82,
    y1: 81.9105,
    x2: 212.231,
    y2: 56.9756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1515_6838",
    x1: 192.902,
    y1: 87.2195,
    x2: 236.788,
    y2: 87.9929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7A69B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1515_6838",
    x1: 200.391,
    y1: 86.86,
    x2: 212.949,
    y2: 61.1217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1515_6838",
    x1: 198.263,
    y1: 84.2605,
    x2: 213.636,
    y2: 98.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1515_6838",
    x1: 170.267,
    y1: 64.9875,
    x2: 187.346,
    y2: 64.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1515_6838",
    x1: 201.579,
    y1: 63.3555,
    x2: 195.189,
    y2: 49.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B814E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1515_6838",
    x1: 201.275,
    y1: 130.494,
    x2: 197.291,
    y2: 113.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B814E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1515_6838",
    x1: 192.459,
    y1: 146.255,
    x2: 232.947,
    y2: 143.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1515_6838",
    x1: 170.267,
    y1: 133.01,
    x2: 187.346,
    y2: 133.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1515_6838",
    x1: 229.353,
    y1: 79.3661,
    x2: 224.678,
    y2: 69.3581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B814E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1515_6838",
    x1: 200.004,
    y1: 49.4744,
    x2: 216.815,
    y2: 64.6459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1515_6838",
    x1: 194.394,
    y1: 49.6134,
    x2: 230.846,
    y2: 49.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1515_6838",
    x1: 212.053,
    y1: 61.9739,
    x2: 206.001,
    y2: 61.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9997C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1515_6838",
    x1: 184.085,
    y1: 44.4694,
    x2: 207.36,
    y2: 56.3214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9997C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1515_6838",
    x1: 210.837,
    y1: 60.453,
    x2: 222.389,
    y2: 60.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A3F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1515_6838",
    x1: 214.983,
    y1: 53.0415,
    x2: 215.923,
    y2: 56.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A5813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1515_6838",
    x1: 218.216,
    y1: 56.1943,
    x2: 216.28,
    y2: 52.8494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1515_6838",
    x1: 204.315,
    y1: 55.3644,
    x2: 240.767,
    y2: 55.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAA99F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1515_6838",
    x1: 223.495,
    y1: 59.6493,
    x2: 222.638,
    y2: 58.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#647926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1515_6838",
    x1: 219.709,
    y1: 62.6355,
    x2: 235.083,
    y2: 76.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1515_6838",
    x1: 326.358,
    y1: 262.891,
    x2: 327.603,
    y2: 267.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F6775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1515_6838",
    x1: 327.518,
    y1: 256.227,
    x2: 332.054,
    y2: 264.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436775"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1515_6838",
    x1: 188.065,
    y1: 237.037,
    x2: 187.954,
    y2: 243.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A68B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1515_6838",
    x1: 183.367,
    y1: 236.843,
    x2: 181.348,
    y2: 243.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F825B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1515_6838",
    x1: 178.724,
    y1: 234.493,
    x2: 176.788,
    y2: 241.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F825B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1515_6838",
    x1: 177.094,
    y1: 233,
    x2: 171.342,
    y2: 238.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F825B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1515_6838",
    x1: 192.736,
    y1: 237.369,
    x2: 194.257,
    y2: 242.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A68B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1515_6838",
    x1: 196.55,
    y1: 235.101,
    x2: 199.675,
    y2: 240.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A68B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1515_6838",
    x1: 199.48,
    y1: 233.11,
    x2: 204.153,
    y2: 238.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F825B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1515_6838",
    x1: 206.057,
    y1: 89.4868,
    x2: 187.071,
    y2: 89.4868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19E8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1515_6838",
    x1: 296.675,
    y1: 246.217,
    x2: 297.726,
    y2: 249.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#927745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C804C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1515_6838",
    x1: 198.982,
    y1: 241.433,
    x2: 176.972,
    y2: 221.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B3A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1515_6838",
    x1: 186.739,
    y1: 206.316,
    x2: 189.696,
    y2: 206.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBAAA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1515_6838",
    x1: 186.435,
    y1: 200.204,
    x2: 189.475,
    y2: 200.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDBFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1515_6838",
    x1: 212.054,
    y1: 173.659,
    x2: 171.981,
    y2: 173.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBFB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1515_6838",
    x1: 212.082,
    y1: 172.027,
    x2: 171.981,
    y2: 172.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBFB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1515_6838",
    x1: 191.797,
    y1: 148.966,
    x2: 186.791,
    y2: 155.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBBFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B8B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1515_6838",
    x1: 200.778,
    y1: 152.367,
    x2: 182.04,
    y2: 154.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDBFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1515_6838",
    x1: 210.783,
    y1: 174.184,
    x2: 161.562,
    y2: 174.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5BBB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1515_6838",
    x1: 198.429,
    y1: 174.461,
    x2: 134.257,
    y2: 171.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1B7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3CAC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1515_6838",
    x1: 195.941,
    y1: 172.939,
    x2: 131.576,
    y2: 169.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8BFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1515_6838",
    x1: 196.135,
    y1: 170.893,
    x2: 131.577,
    y2: 167.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8BFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1515_6838",
    x1: 265.531,
    y1: 202.002,
    x2: 254.715,
    y2: 222.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1515_6838",
    x1: 287.538,
    y1: 327.944,
    x2: 321.616,
    y2: 327.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987F58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1515_6838",
    x1: 265.159,
    y1: 100.635,
    x2: 259.102,
    y2: 87.6962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B814E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1515_6838",
    x1: 282.736,
    y1: 80.8363,
    x2: 260.211,
    y2: 87.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1515_6838",
    x1: 182.708,
    y1: 293.913,
    x2: 179.75,
    y2: 288.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1515_6838",
    x1: 179.434,
    y1: 290.221,
    x2: 180.829,
    y2: 296.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_6838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 397,
    height: 428,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1515_6838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.3473,
    height: 132.387,
    fill: "white",
    transform: "translate(264.269 201.717)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindDifferent);
export default __webpack_public_path__ + "static/media/findDifferent.4b4fbd71d5a6eb8df10a5162d57a9f53.svg";
export { ForwardRef as ReactComponent };